import { CalendarNext, CalendarPrev, CalendarToday, Eventcalendar } from '@mobiscroll/react';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ChangeCircleRoundedIcon from '@mui/icons-material/ChangeCircleRounded';
import { Accordion, AccordionDetails, Box, Button, Card, CardContent, Checkbox, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { Stack } from '@mui/system';
import { process } from '@progress/kendo-data-query';
import { guid } from '@progress/kendo-react-common';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18_en from '../../../../jsonStore/i18_en.json';
import { drageItemsReducer } from '../../../../shared/ReduxStore/Reducers/dragReducer';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import ToggleMenuForConfig from '../../../../shared/common-utilities/common/toggleMenuForConfig/toggleMenuForConfig';
import { CommonConst as Consts } from '../../../../shared/common-utilities/enums/CommonConst.jsx';
import { PlanFunctionsForFlag as PlanFlag, PlanFunctionsForFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum.jsx';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { ApiConst, actionCode, agendaCodes, baseUrl, fetchSavedView, getPartialTrip, getRoutes, planGroupResources, planMovementsNew, plannedActions, routes } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService';
import ManualModeWhIcon from '../../../../shared/common-utilities/utils/ManualModeWhIcon.jsx';
import ContextMenu from "../../common/ContextMenu/ContextMenu";
import ModalComponent from '../Modal/ModalComponent.js';
import WindowComponent from '../Window/WindowComponent.jsx';
import CustomScheduleEvent from './CustomScheduleEvent';
import ContainerResource from './CustomeResource/ContainerResource.jsx';
import { DriverResource } from './CustomeResource/DriverResource.jsx';
import { TrailerResource } from './CustomeResource/TrailerResource.jsx';
import { TruckResource } from './CustomeResource/TruckResource.jsx';
import VariousResource from './CustomeResource/VariousResource.jsx';
import { refreshPartialTrip, refreshRouteAndPT, setPartialTripReducer, setPlannedOnAgenda, setRemovePartialTrip } from '../../../../shared/ReduxStore/Reducers/partialTripReducer.jsx';
import { refreshMovement, setPlannedOnAgendaMovement } from '../../../../shared/ReduxStore/Reducers/movementsReducer.jsx';
import { useCallback } from 'react';
import Spinner from '../Spinner/Spinner.jsx';

let service = getSetDataService();
let apiService = commonApiService();
let dataService = dataStorageService();

export const EventCalender = (props) => {

	const {entity, gridFlagVal, planRelatedAction, initialFetchReadLinkData, iconActive, handleEventHoverIn, handleEventHoverOut, agendaAction, sendDataToParent, eventCard, remarksAction, routeIdAction, resourceAction, prtFilterComponents, selectedDate, maxDate, minDate, days, categories, viewType, onCategoryChange, onChange, removeAction,setTooltipOpen, dataRelatedAction} = props;

	const partialTripReducerData = useSelector(state => state.partialTrip);

	const [isShowToggleForConfig, setFlagShowToggleForConfig] = useState(false);
	const [toggleconfigcheckboxesplan, setToggleconfigcheckboxesplan] = useState({});
	const [toggleconfigcheckboxes, setToggleconfigCheckboxes] = useState({});
	const [disableReportIcon, setDisableReportIcon] = useState(true);
	const [disablePTCOIcon, setDisablePTCOIcon] = useState(true);
	const [disableResourceIcon, setDisableResourceIcon] = useState(true)
	const [manualModeIcon,setManualModeIcon] = useState(false)
	const [changeSeqIcon,setChangeSeqIcon] = useState(false)
	const [toggleIcon, setToggleIcon] = useState(true)
	const [selectedEvent, setSelectedEvent] = useState([])
    const [checkedResource, setCheckedResource] = useState([])	
    const [myResources, setMyResources] = useState([])
	const [myEvents, setMyEvents] = useState([...props?.plannedAction, ...props?.eventData])
    const [myConnections, setMyConnections] = useState([])
    const [openMail, setOpenMail] = useState({ resource: "", isOpened: false });
    const [contextData, setContextData] = useState({});
    const [showTimelineContextMenu, setShowTimelineContextMenu] = useState(false);
	const [toggleconfigActions, setToggleconfigActions] = useState([]);
	const [toggleconfigCard, setToggleconfigCard] = useState([]);
	const toggleconfigRemove = useRef([]);
	const [tempToggleconfigActions, setTempToggleconfigActions] = useState([]);
	const [toggleDraggedItem, setToggleDraggedItem] = useState([]);
	const [commonPopupParameters, setCommonPopupParameters] = useState({});
	const [errorMessage, setErrorMessage] = useState(null);
	const [openConfirmationModal, setopenConfirmationModal] = useState(false);
	const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
	const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
	const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
	const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
	const [isDisplayDrillDownButton, setIsDisplayDrillDownButton] = useState(false);
	const [drillDownButtonURL, setDrillDownButtonURL] = useState();
    const [isShow, setFlagShow] = useState(false);
    const [expanded, setExpanded] = useState('panel1');
	const [isAgendaRemark, setIsAgendaRemark] = useState(false)
	const [movementId,setMovementId] = useState([])
    const [plannedAction, setPlannedAction] = useState(props?.plannedAction);
	const [pataAction, setDataAction] = useState(dataRelatedAction);
    const [eventData, setEventData] = useState(props?.eventData)
    const [openModalPopUp,setOpenModalPopUp] = React.useState(false);
	const [batchTCIcon,setBatchTCIcon] = useState(false)
	const [visibleOverlappedEvents,setVisibleOverlappedEvents] = useState([])
	const [isLoading, setIsLoading] = React.useState(false);

	const currentonDropEventData = useRef({})
	const currentHoverEvent = useRef({})
	const nvtTrailerType = useRef([])
	const nvtVehicleType = useRef([])
	const nvtQualificationType = useRef([])
	const isEventUpdated = useRef(true)
	const hiddenOverlappedEvents = useRef([])
	const drageItems = useSelector(state => state.drag);
	const initialSavedViewObj = { [entity]: service.initialViewsObj }
    const userID = localStorage.getItem('userID');
	const dispatch = useDispatch();
  	const displayMoveToLUToolTip = useMemo(() => <>Move To LU<Typography>Assign the different  movement goods towards the correct loading units, just to know which loading unit holds which goods. This is necessary before you split up a partial trip that has more than 1 loading unit attached.</Typography></>, []);		  

	const offSet = useRef({
        left: 0,
        top: 0,
    });
	const currentDraggedEvent = useRef(null)
	const resourceIdRef = useRef(null)
	const divRef = React.createRef()

	const planFunctionTooltip = (key, title) => {
		if (key === 'Create Trips') {
		  return displayCreateTripToolTip;
		} else if (key === 'Process Trips') {
		  return displayProcessTripToolTip;
		} else if(key === 'Move To LU') {
		  return displayMoveToLUToolTip;
		}else {
		  return title;
		}
	}
	const getSelectedValues = () => {
		if (isAgendaRemark) {
			return selectedEvent?.[0]?.id || "";
		} else {
			if (selectedEvent?.length > 0) {
				if (selectedEvent[0].isAgendaItem) {
					return selectedEvent[0].id;
				} else {
					return selectedEvent[0]?.partialTripId || selectedEvent[0]?.data?.[0]?.partialTripId || "";
				}
			} else {
				return "";
			}
		}
	}
	const getResourceValues = () => {
		return checkedResource[0]?.id
	}
	const getSelectedRoute = () => {
		if(selectedEvent && selectedEvent.length > 0) {
			if(viewType == Consts.Route && selectedEvent[0]?.routeId) {
				return selectedEvent[0]?.routeId || selectedEvent[0]?.data[0]?.routeId 
			} else if (selectedEvent[0]?.partialTripId ){
				return selectedEvent[0]?.partialTripId || selectedEvent[0]?.data[0]?.partialTripId 
			} else {
				return selectedEvent[0]?.id 
			}
		} else {
			return ""
		}
	}
	const onRefreshIconClick = (flag = null) => {
		if(flag === 'manualRefresh') {
			sendDataToParent(true, 'manualRefresh');
			return
		}
		sendDataToParent(true, 'refresh');
	}
	
	const onPlanButtons = (e, Id, contextData, isCustomActions = false) => {
		if (e == "send-to obc") {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.sendTripOBC', {});
		} else if (e == 'exchange-trailer') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.exchangeTrailer', {});
		} else if (e == 'split-trailer') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.splitTrailerPB', {});
		} else if (e == 'insert-shipping line') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.insertShippingLine', {});
		} else if (e == "insert-begin - end action") {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.insertBeginEndAction', {});
		} else if (e == "transfer-goods") {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.transferGoods', {});
		} else if (e == "split-trip") {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.splitTrip', {});
		} else if (e == 'move-to lu') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.moveToLU', {});
		} else if (e == 'e-mail-trip sheet') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.emailTripSheet', {});
		} else if (e == 'print-trip sheet') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.printTripSheet', {});
		} else if (e == 'print-cmr') {
			onPlanButtonsNetworkCall(getPartialTrip, null, Id, 'Microsoft.NAV.printCMR', {});
		} else if (e == 'view-e-cmr') {
			onPlanButtonsNetworkCall(getPartialTrip, null, Id, 'Microsoft.NAV.viewECMR', {});
		} else if (e == 'create-e-cmr') {
			onPlanButtonsNetworkCall(getPartialTrip, null, Id, 'Microsoft.NAV.createECMR', {});
		} else if (e == 'print-outsource confirmation') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.printOutsourceConfirmation', {});
		} else if (e == 'e-mail-outsource confirmation') {
			onPlanButtonsNetworkCall(getPartialTrip,null,Id,'Microsoft.NAV.emailOutsourceConfirmation', {});
		} else if (e == "report" || e == "reports") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.reports', {});
		} else if (e == "regroup") {
			onRegroupTripIconClick(Id);
		} else if (e == "partialtrip-card") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.getUrlPartialTrip', {});
		} else if (e == "trip-card") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.getUrlTrip', {});
		} else if (e == "shipment-card") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.getUrlShipment', {});
		} else if (e == "all-resources") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.resources', {});
		} else if (e == "file-card") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.getUrlFileTpt', {});
		} else if (e == "show-obc messages") {		
			const resData =  contextData?.inst || checkedResource[0]
			onPlanButtonsNetworkCall(planGroupResources,null, resData.oldId,'Microsoft.NAV.showOBCMessages', {});
		} else if (e == "show-resource card") {
			const resData =  contextData?.inst || checkedResource[0]
			onPlanButtonsNetworkCall(planGroupResources,null, resData.oldId,'Microsoft.NAV.resourceCard', {});
		} else if (e == 'insert-extra action') {
			apiService.get(actionCode).then((response)=>{
			  	PlanNewPartialTrip(getPartialTrip,null,Id,'Microsoft.NAV.insertExtraAction',null,{data:response.value},PlanFunctionsForFlag.InsertExtraAction)
			})
		} else if (e == "calculate") {
			onCalculateIconClick(Id);
		} else if (e === 'remark') {
			const resourcId = service.findResourceById(myResources,contextData?.event?.resource)?.oldId;
			resourceIdRef.current = resourcId;
			PlanNewPartialTrip(planGroupResources,null,resourcId,'Microsoft.NAV.insertAgendaRemark',null,{defaultValue:contextData?.event?.date},PlanFunctionsForFlag.Remark)
		} else if (e === 'agenda-item') {
			const resourcId = service.findResourceById(myResources,contextData?.event?.resource)?.oldId;
			resourceIdRef.current = resourcId;
			apiService.get(agendaCodes).then((response)=>{
				PlanNewPartialTrip(planGroupResources,null,resourcId,'Microsoft.NAV.insertAgendaItem',null,{defaultValue:contextData?.event?.date,data:response.value},PlanFunctionsForFlag.AgendaItem)
			})
		} else if (e === "delete-selection") {
			callPlanFunctionPostWithIdAPI(plannedActions,null,selectedEvent[0]?.id,'Microsoft.NAV.deleteAgendaAction', {"input":""}, PlanFunctionsForFlag.DeleteSelection, true, false, i18_en.operationSuccessful);
		} else if (e === "send-to back") {
			console.log("send-to back")
		} else if (e === "show-details action item/ remark") {
			if(contextData?.event?.event?.isAgendaItem) {
				apiService.get(agendaCodes).then((response)=>{
					PlanNewPartialTrip(plannedActions,null,Id || selectedEvent[0]?.id,'Microsoft.NAV.updateAgendaAction',null,{data:response.value},PlanFunctionsForFlag.ShowDetailsActionItemRemark)
				})
			} else {
				PlanNewPartialTrip(plannedActions,null,Id || selectedEvent[0]?.id,'Microsoft.NAV.updateAgendaAction',null,{},PlanFunctionsForFlag.ShowDetailsActionItemRemark)
			}
		} else if (e == 'fixed') {
			let isRoute = viewType == Consts.Route
			onPlanButtonsNetworkCall(isRoute?getRoutes:getPartialTrip,null, Id,'Microsoft.NAV.'+(isRoute?'toggleRouteFixed':'toggleFixedActionsForPt'), {[isRoute?"isNewFixedState":"isFixedActions"]: !selectedEvent[0]?.fixedActionTime},true);
		} else if (e == "contract-out") {
			onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.contractOut', {});
		} else if (e == 'send-message to obc') {
			const resData =  contextData?.inst || checkedResource[0]
			onPlanButtonsNetworkCall(planGroupResources,null, resData.oldId,'Microsoft.NAV.sendOBCMessages', {});
		} else if (e === 'manual-mode') {
			if(Id)
				onPlanButtonsNetworkCall(getPartialTrip,null, Id,'Microsoft.NAV.toggleManualMode', {manualMode:manualModeIcon},true);
		} else if (e == 'delete-partial trip') {
			callPlanFunctionPostWithIdAPI(getPartialTrip,null,Id,'Microsoft.NAV.deletePartialTrip', {"input":"{}"}, PlanFunctionsForFlag.DeletePartialTrip, true, false, i18_en.operationSuccessful);
		} else if (e === 'remove-from current resource') {
			const resourceType = service.findResourceById(myResources,selectedEvent[0]?.resource)?.resourceType;
			resourceIdRef.current = resourceType
			let obj = {
				"input": JSON.stringify({resourceType:resourceType})
			}
			callPlanFunctionPostWithIdAPI(getPartialTrip,null,Id,'Microsoft.NAV.removeFromCurrentResource', obj, PlanFunctionsForFlag.RemoveFromCurrentResource, true, false, i18_en.operationSuccessful);
		} else if (e === 'remove-from all resources') {
			console.log('remove-from-all resources')
		} else if(e === 'change-sequence') {
			if(contextData == undefined) {
				setChangeSeqIcon(!changeSeqIcon)
			} else {
				const {start,routeId} = contextData?.event?.event
				callPlanFunctionPostWithIdAPI(getRoutes,null,routeId,'Microsoft.NAV.changeRouteSequence', service.parseDate(start),PlanFunctionsForFlag.ChangeSequence, true, false, i18_en.operationSuccessful);
			}
		}
		else if(e === 'batch-trip creation'){
			if(eventData.length > 0)
				onPlanButtonsNetworkCall(getPartialTrip,null,eventData[0].partialTripId,'Microsoft.NAV.batchTripCreation', {});
		}else if (e === 'truck-appointment overview') {
			onPlanButtonsNetworkCall(getPartialTrip, null, Id, 'Microsoft.NAV.showTruckAppointmentOverview', {});		
		}else if (e === 'truck-appointment new') {
			onPlanButtonsNetworkCall(getPartialTrip, null, Id, 'Microsoft.NAV.newTruckAppointment', {});	
		}else if (e === 'truck-appointment add to') {
			onPlanButtonsNetworkCall(getPartialTrip, null, Id, 'Microsoft.NAV.addToTruckAppointment', {});
		}else if(e ==='refresh'){
			sendDataToParent(true, 'manualRefresh');
		}
	}
	const fixedData = (value,flag) => {
		let newEventData = []		

		if(viewType == Consts.Route) {
			newEventData = eventData.map(item => 
				item?.routeId == value ? {
						...item, fixedActionTime : !item?.fixedActionTime 
				} : item
			)
			setEventData(newEventData)
		} else {
			const index =  eventData.findIndex(p => p.partialTripId == value)
			if(index != -1){                    
				newEventData = myEvents
				newEventData[index].fixedActionTime = !newEventData[index].fixedActionTime
				let newEventDataTrp = eventData.map(item => 
					item?.partialTripId == value ? {
							...item, fixedActionTime : newEventData[index].fixedActionTime
					} : item
				)
				setEventData(newEventDataTrp)
			}                
		}
		// setMyEvents([...plannedAction,...newEventData])
	}
	const onPlanButtonsNetworkCall = (url, flag, id, routeExpand, obj, isDisplaySnackbar,otherData = {}) => {
		setIsLoading(true);
		apiService.postWithId(url,flag, id,routeExpand, obj).then(response => {
			if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
				setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
			} else {
				if (isDisplaySnackbar) {
					if(routeExpand != 'Microsoft.NAV.getLinkedRoutes')
						setSuccessSnackbarAndMessage(i18_en.operationSuccessful, false);
					if(['Microsoft.NAV.toggleRouteFixed','Microsoft.NAV.toggleFixedActionsForPt'].includes(routeExpand)) {
						
						fixedData(viewType == Consts.Route ? selectedEvent[0]?.routeId : selectedEvent[0]?.partialTripId,Consts.fixed)
					} else if('Microsoft.NAV.getLinkedRoutes' === routeExpand) {
						let res = JSON.parse(response.value)
						res.value.map((item)=>item.id)
						res.value.push({id:id})
						setMovementId(res.value)
					} else if (routeExpand === 'Microsoft.NAV.toggleManualMode') {
						let newEventData = eventData.map((item)=>{
							if(item.partialTripId === id) {
								return {
									...item,
									inManualMode : !manualModeIcon
								}
							} else {
								return item
							}
						})
						setEventData(newEventData)
						setManualModeIcon(!manualModeIcon)
					} else if (routeExpand === 'Microsoft.NAV.changeRouteSequence') { 
						sendDataToParent(true,"refresh")
					} else {	
						// setSelectedEvent([])
					}
				//   setDrillDownFlagAndURL(true, response.value);
				} else {
					const url = response.value;
					window.open(url, '_blank');
				}
			}
		}).finally(()=>{
			setIsLoading(false);
			// setTimeout(() => {
			// 	setIsLoading(false);	
			// }, 50000);
		})
	}
	const onRegroupTripIconClick = (id) => {
		const obj = {
		  "input": "{}"
		};
		callPlanFunctionPostWithIdAPI(getPartialTrip,null,id,'Microsoft.NAV.regroupTrip', obj, PlanFunctionsForFlag.RegroupTrip, true, false, i18_en.operationSuccessful);
	}
	const callPlanFunctionPostWithIdAPI = (url, flag, id, routeExpand, obj, forFlag, isRefresh, isSendDataToParent = false, snackbarMessage = i18_en.operationSuccessful) => {
		apiService.postWithId(url, flag, id, routeExpand, obj).then(response => {
			if (response) {
				if (response.error) {
					setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
					if(forFlag == PlanFunctionsForFlag.ChangeSequence) {
						let newEventData = eventData.map((event) => {
							return event.id === currentDraggedEvent?.current?.event?.id ? currentDraggedEvent?.current?.event : event
						})
						setEventData(newEventData)
					}
				} else {
					const result = JSON.parse(response?.value);
					if (result) {
						if (service.apiOKResultChecker(result)) {
							setSuccessSnackbarAndMessage(snackbarMessage);
							if (isRefresh) {
								if(forFlag === PlanFunctionsForFlag.DeleteSelection)
									sendDataToParent(true,'refreshAction')
								else 
									onRefreshIconClick();
							}
							setopenConfirmationModal(false);
						} else if (result.parameters[0] !== null && result.parameters[0] !== undefined && (result.parameters[0].name === 'confirmation' || result.parameters[0].name === 'warnings')) {
							const params = {
								title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
								id: id,
								for: forFlag,
								parameters: result.parameters,
								result: result,
								obj : obj
							}
							setopenConfirmationModal(true);
							setCommonPopupParameters(params);
						} else {
							setopenConfirmationModal(false);  
						}
					} else {
						setopenConfirmationModal(false);
					}
				}
			}
		})
	}
	const onCalculateIconClick = (selectedId, param = null) => {
		// setIsLoading(true);
		if(param == null) {
			param= {
				"input" : "{}"
			}
		}
		apiService.postWithId(getPartialTrip,null,selectedId,'Microsoft.NAV.calculateIncludingActionTimes', param).then((response) => {
			if (response !== null && response !== undefined) {
				if (response.error !== null && response.error !== undefined && response.error) {
					setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
				} else {
					const result = JSON.parse(response?.value);
					if (service.apiResultChecker(result)) {
						const param = {
							title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
							parameters: result.parameters,
							for: PlanFunctionsForFlag.CalculateNotification
						};
						setopenConfirmationModal(true);
						setCommonPopupParameters(param);
						if (service.apiOKResultChecker(result)) {
							setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
						}
					} else if (result?.parameters && result.parameters[0]?.type === 'Dialog.ConfirmSingleLine') {
						const param = {
							title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
							parameters: result.parameters,
							for: PlanFunctionsForFlag.CalculateConfirmation,
						};
						setopenConfirmationModal(true);
						setCommonPopupParameters(param);
					} else {
						if (service.apiOKResultChecker(result)) {
							setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
							onRefreshIconClick('manualRefresh')
							if(window.location.hash.includes("#/CustomView")){
								dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
							}
						}
					}
				}
			}
		})
		//   .catch(error => {
		// 	console.error('API error:', error);
		//   })
		//   .finally(() => {
		// 	setIsLoading(false);
		//   })
	}
	const PlanNewPartialTrip = (url, flag, id, routeExpand, obj = null,data = null,actionFor=null) => {
		const isRemarkItem = ['Microsoft.NAV.insertAgendaRemark','Microsoft.NAV.insertAgendaItem'].includes(routeExpand)
		const isUpdate = ['Microsoft.NAV.updateAgendaAction'].includes(routeExpand)
		if(obj == null) {
			obj= {
				"input" : "{}"
			}
		}
		apiService.postWithId(url,flag,id,routeExpand,obj).then(response => {
			if (response?.value) {
				let result = JSON.parse(response?.value);
				if (result?.parameters && result.parameters[0]?.type === 'APIGrid' && result.parameters[0]?.name === "transportAddress") {
					setCommonPopupParameters({
						title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
						for: PlanFunctionsForFlag.InsertExtraAction,
						movementlines: null,
						result: result.parameters[0].entityName,
						input: null,
						obj: obj
					});
					setOpenModalPopUp(true)

				} else if (result?.parameters && ['Dialog.SelectRadioButton','APIGrid','Edm.String','Label','Edm.Date','Edm.DateTime','Dialog.ConfirmSingleLine','Dialog.Message'].includes(result.parameters[0].type)) {
					if(isRemarkItem) {
						result.parameters = result.parameters.map(item => (
							item.type === 'Edm.Date' || item.type === 'Edm.TimeOfDay'
								? { ...item, defaultValue: data?.defaultValue }
								: item
						));
					}
					const param = {
						title: result?.parameters[0]?.caption ? result?.parameters[0]?.caption : i18_en.navitransTransportPlanning,
						for: actionFor,
						parameters: result.parameters,
						options : data?.data,
						key : data?.key,
						obj : obj,
						id : id,
						result: result?.data
					};
					setopenConfirmationModal(true);
					setCommonPopupParameters(param);
				} else if (result !== null && result !== undefined && result?.status?.toLowerCase() === 'ok') {
					if(isRemarkItem || isUpdate)
						sendDataToParent(true,'refreshAction')
					else{
						if(routeExpand == 'Microsoft.NAV.planOnAgenda'){
							dispatch(setPlannedOnAgenda(true))
							dispatch(refreshPartialTrip({ isRefreshPartialTrip: true }));
							dispatch(setPlannedOnAgenda(false))
						}
						onRefreshIconClick();
					}
					setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
				}
			}else if(response.error){
				setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
				if(routeExpand == "Microsoft.NAV.moveInTimeLine") {
					let newEventData = eventData.map((event) => {
						return event.id === currentDraggedEvent?.current?.event?.id ? currentDraggedEvent?.current?.event : event
					})
					setEventData(newEventData)
				}else if(routeExpand == "Microsoft.NAV.movePlannedAction"){
					let newPlannedActions = plannedAction.map((event) => {
						return event.id === currentDraggedEvent?.current?.event?.id ? currentDraggedEvent?.current?.event : event
					})
					// setMyEvents([...eventData,...newPlannedActions])
					setPlannedAction(newPlannedActions)
				}
			}
		})
	}
	const handleChildState = (e, flag) => {
		if(flag === PlanFunctionsForFlag.PlanMovementsOnAgenda) {
			closeConfirmationModal(e, flag)
			setCommonPopupParameters({});
			setOpenModalPopUp(false)
		}
	}
	const closeConfirmationModal = (e, flag, id = null) => {
		setopenConfirmationModal(false);
		setCommonPopupParameters({});
		if (e && flag && flag === PlanFunctionsForFlag.RegroupTrip) {
			callPlanFunctionPostWithIdAPI(getPartialTrip,null,id,'Microsoft.NAV.regroupTrip', e, flag, true, false, i18_en.operationSuccessful);
		} else if (e && flag && flag === PlanFunctionsForFlag.InsertExtraAction) {
			PlanNewPartialTrip(getPartialTrip,null,getSelectedValues(),'Microsoft.NAV.insertExtraAction',e,{},PlanFunctionsForFlag.InsertExtraAction)
		} else if (e && flag && flag === PlanFunctionsForFlag.Remark) {
			PlanNewPartialTrip(planGroupResources,null,resourceIdRef.current,'Microsoft.NAV.insertAgendaRemark',e,{},PlanFunctionsForFlag.Remark)
		} else if(e && flag && flag === PlanFunctionsForFlag.AgendaItem) {
			PlanNewPartialTrip(planGroupResources,null,resourceIdRef.current,'Microsoft.NAV.insertAgendaItem',e,{},PlanFunctionsForFlag.AgendaItem)
		} else if (e && flag && flag === PlanFunctionsForFlag.CalculateConfirmation) { 
			onCalculateIconClick(selectedEvent[0]?.partialTripId,e);
		} else if (flag && flag === PlanFunctionsForFlag.ChangePTResourceConfirmation) {			
			if(e){
				callAPIChangePtResource(e);	
			}				
			else{
				const index = myEvents.findIndex(e => e.id == currentDraggedEvent.current.event.id)
				if(index != -1){
					myEvents[index].resource = currentDraggedEvent.current.resource
					myEvents[index].resourceData = currentDraggedEvent.current.event.resourceData
				}
				setMyEvents([...myEvents])
			}
		} else if (e && flag && (flag === PlanFunctionsForFlag.RemoveFromCurrentResource || flag === PlanFunctionsForFlag.DeletePartialTrip)) {
			e.confirmation=true
			if(flag === PlanFunctionsForFlag.RemoveFromCurrentResource)
				e.resourceType = resourceIdRef.current
			const param = {
				input: JSON.stringify(e)
			}
			callPlanFunctionPostWithIdAPI(getPartialTrip,null,id,`Microsoft.NAV.${flag === PlanFunctionsForFlag.DeletePartialTrip ? 'deletePartialTrip' : 'removeFromCurrentResource'}`, param, flag, true, false, i18_en.operationSuccessful);
		} else if (e && flag && flag === PlanFunctionsForFlag.DeleteSelection) {
			e.confirmation=true
			const param = {
				input: JSON.stringify(e)
			}
			callPlanFunctionPostWithIdAPI(plannedActions,null,id,`Microsoft.NAV.deleteAgendaAction`, param, flag, true, false, i18_en.operationSuccessful);
		} else if (e && flag && flag === PlanFunctionsForFlag.ShowDetailsActionItemRemark) {
			PlanNewPartialTrip(plannedActions,null,selectedEvent[0]?.id,'Microsoft.NAV.updateAgendaAction',e,PlanFunctionsForFlag.ShowDetailsActionItemRemark)
		} else if (flag && flag === PlanFunctionsForFlag.ConfirmNewPartialTrip) {
			// e.confirmation=true
			if(e){
				const param = {
					input: JSON.stringify(e)
				}
				callPlanFunctionPostWithIdAPI(getPartialTrip,null,id,'Microsoft.NAV.moveInTimeLine',e , PlanFunctionsForFlag.ConfirmNewPartialTrip, true, false, i18_en.operationSuccessful);
			}else{
				// let newEventData = myEvents.map((event) => {
				// 	return event.partialTripId === currentDraggedEvent?.current?.event?.partialTripId ? currentDraggedEvent?.current?.event : event
				// })
				// setMyEvents([...newEventData]);
				setEventData([...props.eventData])
			}
			
		} else if (e && flag && flag === PlanFunctionsForFlag.PlanMovementsOnAgenda) {
			postPlanMovementsAPI(e, e.movementlines)
		} else if (flag && flag === PlanFunctionsForFlag.ChangeSequence) {
			if(e)
				callPlanFunctionPostWithIdAPI(getRoutes,null,id,'Microsoft.NAV.changeRouteSequence', e,PlanFunctionsForFlag.ChangeSequence, true, false, i18_en.operationSuccessful);
			else {
				let newEventData = eventData.map((event) => {
					return event.id === currentDraggedEvent?.current?.event?.id ? currentDraggedEvent?.current?.event : event
				})
				setEventData(newEventData)
			}
		} else if (e && flag && flag === PlanFunctionsForFlag.PlanPartialTripOnAgenda) {
			PlanNewPartialTrip(getPartialTrip,null,id,'Microsoft.NAV.planOnAgenda',e,{},PlanFunctionsForFlag.PlanPartialTripOnAgenda)
		} else if (flag && flag === PlanFunctionsForFlag.MoveMovement) {
			if(e)
				PlanNewPartialTrip(getRoutes,null,id,'Microsoft.NAV.moveInTimeLine',e,{},PlanFunctionsForFlag.MoveMovement)
			else {
				let newEventData = eventData.map((event) => {
					return event.id === currentDraggedEvent?.current?.event?.id ? currentDraggedEvent?.current?.event : event
				})
				setEventData(newEventData)
			}
		} else if (e && flag && flag === PlanFunctionsForFlag.MoveAgendaItem) {
			PlanNewPartialTrip(plannedActions,null,id,'Microsoft.NAV.movePlannedAction',e,{},PlanFunctionsForFlag.MoveAgendaItem)
		}
		setErrorMessage(null);
	}
	const callAPIChangePtResource = (obj) => {
		const url = `${baseUrl}/partialTrips(${currentonDropEventData.current.partialTripId})/${ApiConst.changePtResource}`;
		const param = {
		  input: JSON.stringify(obj)
		}
		// setIsLoading(true);
		apiService.post(url, param).then(response => {
		  if (response !== null && response !== undefined) {
			if (response.error) {
			  setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
			  setEventData([...props.eventData])
			} else {
			  const result = JSON.parse(response?.value);
			  if (result.parameters !== null && result.parameters !== undefined && result.parameters[0].type === 'Dialog.ConfirmSingleLine') {
				const param = {
				  title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
				  description: result.parameters[0].content,
				  for: PlanFunctionsForFlag.ChangePTResourceConfirmation,
				  parameters: result.parameters,
				  result: result,
				  obj : obj
				}
				setopenConfirmationModal(true);
				setCommonPopupParameters(param);
			  } else if (service.apiOKResultChecker(result)) {
				setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
				setopenConfirmationModal(false);
				onRefreshIconClick();
			  }
			}
		  }
		})
		.catch(error => {
		  console.error('API error:', error);
		})
		.finally(() => {
		//   setIsLoading(false);
		})
	}
	const setSuccessSnackbarAndMessage = (message, noDrillDown = true) => {
		setSuccessSnackbarMessage(message);
		setSuccessSnackbarOpen(true);
		if (noDrillDown) {
		  setDrillDownFlagAndURL(false, '');
		}
	}
	const setErrorParameterAndMessage = (errMsg) => {
		setCommonPopupParameters({
		  title: 'Error'
		});
		setErrorMessage(errMsg);
		setopenConfirmationModal(true);
	}
	const handleSuccessSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
		  return;
		}
		setSuccessSnackbarOpen(false);
	};
	const handleErrorSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
		  return;
		}
		setErrorSnackbarOpen(false);
	};
	const setDrillDownFlagAndURL = (flag = false, drillDownULR = '') => {
		setIsDisplayDrillDownButton(flag);
		setDrillDownButtonURL(drillDownULR);
	}
	const enableDisableIcon = (flag) => {
		setDisableReportIcon(flag)
		setDisablePTCOIcon(flag)
		if(viewType == Consts.Route)
			setToggleIcon(flag)
	}
	const handleSelectedEventsChange = (event) => {
		if(event?.events[0]?.isDummyEvent || event?.events[0]?.isExtraDummyEvent || event?.events[0]?.isRemark || event?.events[0]?.isAgendaItem){
			setShowTimelineContextMenu(false)
			enableDisableIcon(true)
			setSelectedEvent([])
		}
		setIsAgendaRemark(event?.events[0]?.isRemark !== undefined)
		if(event?.events.length > 0 && !event?.events[0]?.isRemark && !event?.events[0]?.isAgendaItem && !event?.events[0]?.isDummyEvent && !event?.events[0]?.isExtraDummyEvent) {
			// let newEvent = event?.events[0];
			// delete newEvent?.popupType
			if(window.location.hash.includes("#/CustomView")){
				let obj = {
					tripNumber: event?.events[0].partialTripId,
					// partialTrips: [newEvent],
					guid: props.guid,
					customView: props.customView
				};
				dispatch(setPartialTripReducer(obj));
				dispatch(setRemovePartialTrip(false));
			}

			setSelectedEvent(event.events)
			setManualModeIcon(event?.events[0]?.inManualMode)
			if(event.events.length === 0 || event.events.length > 1){
				enableDisableIcon(true)
			} else {
				enableDisableIcon(false)
			}
		} else if (event?.events.length > 0 && (event?.events[0]?.isRemark || event?.events[0]?.isAgendaItem)) {
			if(window.location.hash.includes("#/CustomView")){
				let obj = {
					tripNumber: '',
					// partialTrips: [newEvent],
					guid: props.guid,
					customView: props.customView
				};
				dispatch(setPartialTripReducer(obj));
				dispatch(setRemovePartialTrip(true));
			}
		}
	}
	const handleCellClick = (e) => {
		setShowTimelineContextMenu(false)
		setSelectedEvent([])
		enableDisableIcon(true)
		const obj = {
            tripNumber: 0,
            partialTrips: [],
			guid: props.guid,
			customView: props.customView
		};
		dispatch(setPartialTripReducer(obj));
		dispatch(setRemovePartialTrip(true));
	}
	const fetchUpdateSavedViews = (title, savedViewData, isFromToggleConfig, showMsg) => {
		const filterUrl = `?$filter=(title eq '${title}' and userID eq '${userID}')`;
		const url = `${fetchSavedView}${filterUrl}`
		apiService.get(url).then(response => {
			if (response?.value?.length !== 0) {
				apiService.put(response.value[0]["userMetadata@odata.mediaReadLink"], response.value[0]["@odata.etag"], savedViewData).then(response => {
					if (showMsg) {
					//   setSuccessSnackbarAndMessage(i18_en.operationSuccessful);
					}
				})
			}
		})
	}
	const showToggleMenu = () => {
        setFlagShowToggleForConfig(!isShowToggleForConfig);
    }
	const toggleDataActionsRendering = (checkboxes) => {
		setToggleconfigCheckboxes(checkboxes);
		saveToggleActionSelectedData('Data', checkboxes);
	};
	const toggleDataActionsRenderingPlan = (checkboxesPlan) => {
		setToggleconfigcheckboxesplan(checkboxesPlan);
		saveToggleActionSelectedData('Plan', checkboxesPlan);
	};
	const droppedItemsChangeForRightClick = (droppedItems) => {
		getToggleConfigData(droppedItems);
		saveToggleActionSelectedData('Action', droppedItems);
	}
	const saveToggleActionSelectedData = (flag, checkboxSelected) => {
		const views = localStorage.getItem(entity + 'Savedview');
		const updatedView = views ? JSON.parse(views) : initialSavedViewObj;
		const toggleActions = {
			toggleActions: {
				dataRelatedAction: flag === 'Data' ? checkboxSelected : toggleconfigcheckboxes,
				planRelatedAction: flag === 'Plan' ? checkboxSelected : toggleconfigcheckboxesplan,
				actions: flag === 'Action' ? checkboxSelected : toggleconfigActions
			}
		};
		updatedView[entity].actions = toggleActions;
		localStorage.setItem(entity + 'Savedview', JSON.stringify(updatedView));
		fetchUpdateSavedViews(entity, updatedView, true, false);
	};
	const getToggleConfigData = (droppedItems) => {
		let updatedDroppedItems = droppedItems.map(item => {
		  	if (typeof item === 'string') {
				return { title: item, source: data?.gridPlanAction?.includes(item) ? "planRelatedAction" : "dataRelatedAction" };
		  	} else {
				return item;
		  	}
		});
		const dropItemActionList = updatedDroppedItems?.filter(x => (x.source === 'dataRelatedAction' || x.source === 'planRelatedAction'));
		setToggleconfigActions(dropItemActionList);
		setTempToggleconfigActions(dropItemActionList);
		setToggleDraggedItem(updatedDroppedItems);
	}
	const getReadLinkData = (updatedViews, response) => {
		if (response !== null && response !== undefined) {
		  const resData = response[entity];
		  if (resData !== undefined && resData !== null) {
			updatedViews[entity].savedViews = resData.savedViews;
			updatedViews[entity].sortings = resData.sortings;
			if (resData?.actions?.toggleActions !== null && resData?.actions?.toggleActions !== undefined) {
				if (resData.actions.toggleActions.planRelatedAction !== null && resData.actions.toggleActions.planRelatedAction !== undefined) {
					Object.entries(resData.actions.toggleActions.planRelatedAction).map(([key, value]) => {
						if (key !== planRelatedAction?.find(x => x === key) && value === true) {
							resData.actions.toggleActions.planRelatedAction[key] = false;
						}
					})
				}
				if (resData.actions.toggleActions.dataRelatedAction !== null && resData.actions.toggleActions.dataRelatedAction !== undefined) {
					Object.entries(resData.actions.toggleActions.dataRelatedAction).map(([key, value]) => {
						if (key !== pataAction?.find(x => x === key) && value === true) {
							resData.actions.toggleActions.dataRelatedAction[key] = false;
						}
					})
				}
				const droppedItems = resData.actions.toggleActions?.actions;
				getToggleConfigData(droppedItems);
				setToggleconfigcheckboxesplan(resData.actions.toggleActions.planRelatedAction);
				setToggleconfigCheckboxes(resData.actions.toggleActions.dataRelatedAction);
				updatedViews[entity].actions = resData.actions;
			}
		  }
		}
	}
	const toggleOpenMail = (data) => {
	}
	const handleClick = () => {
        setFlagShow(!isShow);
    }
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
	const onCellRightClick = (event, inst) => {
		if(window.location.hash.includes("#/CreateCustomView")) {
			return;
		}
		setSelectedEvent([])
		setIsAgendaRemark(false)
        const isDomEvent = !!event?.domEvent;
        const left = isDomEvent ? event.domEvent.clientX : event.clientX;
        const top = isDomEvent ? event.domEvent.clientY : event.clientY;
        offSet.current = { left, top };

		const newContextMenuItems =  agendaAction.map(title => ({
			title,
			source: "agendaAction"
		}));

		if(isDomEvent)
			setToggleconfigActions(newContextMenuItems);
		else {
			let newContextMenuItems =  tempToggleconfigActions.filter(item => resourceAction.includes(item.title)); 
			if([Consts.TRAILERS,Consts.CONTAINERS].includes(iconActive))
				newContextMenuItems = newContextMenuItems.filter(item => item.title != Consts.ShowOBCMessages)
			if([Consts.TRAILERS,Consts.CONTAINERS,Consts.CHASSIS,Consts.VARIOUS].includes(iconActive))
				newContextMenuItems = newContextMenuItems.filter(item => item.title != PlanFlag.SendMessageToOBC)
			if(checkedResource.length > 1)
				newContextMenuItems = newContextMenuItems.filter(item => item.title != Consts.ShowOBCMessages && item.title != Consts.ShowResourceCard)

			setToggleconfigActions(newContextMenuItems)
		}
		setToggleconfigCard([])
		toggleconfigRemove.current = []
        setContextData({ event, inst });
        setShowTimelineContextMenu(true);
    }	
	const onEventRightClick = (event,inst) => {
		if(event?.event?.isExtraDummyEvent || event?.event?.isDummyEvent) {
			onCellRightClick(event,inst)
			return
		}
		
		setTooltipOpen(false)
		const isDomEvent = !!event?.domEvent;
        const left = isDomEvent ? event.domEvent.clientX : event.clientX;
        const top = isDomEvent ? event.domEvent.clientY : event.clientY;
		setIsAgendaRemark(event.event?.isRemark !== undefined)
		if(event?.event?.isRemark || event?.event?.isAgendaItem) {
			offSet.current = { left, top };
			const newContextMenuItems =  remarksAction.map(title => ({
				title,
				source: "agendaAction"
			}));
			setToggleconfigActions(newContextMenuItems);
			setToggleconfigCard([])
			toggleconfigRemove.current = []
			setSelectedEvent([event?.event]);
			let obj = {
				tripNumber: "",
				// partialTrips: [newEvent],
				guid: props.guid,
				customView: props.customView
			};
			dispatch(setPartialTripReducer(obj));
			dispatch(setRemovePartialTrip(true));
		} else {
			let obj = {
				tripNumber: event?.event.partialTripId,
				// partialTrips: [newEvent],
				guid: props.guid,
				customView: props.customView
			};
			dispatch(setPartialTripReducer(obj));
			dispatch(setRemovePartialTrip(false));
			offSet.current = { left, top };
			let newContextMenuItems =  tempToggleconfigActions.filter(item => !resourceAction.includes(item.title) && !eventCard.includes(item.title));   
			if(manualModeIcon) {
				newContextMenuItems = newContextMenuItems.filter(item => item.title !== Consts.Calculate)
			}
			// if(selectedEvent.length == 2 && selectedEvent.some(e => e.id == event.event.id)){      
			//   newContextMenuItems.push("Change Sequence")
			// }
			const newContextCardItems =  tempToggleconfigActions.filter(item => eventCard.includes(item.title));    
			setToggleconfigCard(newContextCardItems)
			toggleconfigRemove.current = removeAction
			setToggleconfigActions(newContextMenuItems);						
			setSelectedEvent([event?.event]);	
			enableDisableIcon(false)		
		}
		setContextData({ event, inst });
		setShowTimelineContextMenu(true);
	}
	const handleDragStart = (event, dragType,resource) => {

        setTimeout(() => {
            const obj = {
                source: 'agenda',
                destination: 'agenda',
                eventType: iconActive,
                isTripGenerated: false,
                items: resource
            }
            dispatch(drageItemsReducer(obj))
        }, 0);
    };
	const onEventDragStart = (event, dragType) => {
		currentDraggedEvent.current = _.cloneDeep({
			action: event.action,
			event: event.event,
			resource: event.resource,
		  });	
		setTooltipOpen(false)
		if(!event.event.isRemark && !event.event.isAgendaItem) {
			if(event.action === 'move' && viewType == Consts.Movement) {
					onPlanButtonsNetworkCall(getRoutes,null, event?.event?.routeId,'Microsoft.NAV.getLinkedRoutes', {},true);
			}
		}
    };
	const checkRouteOverlap = (args)=>{
	// check if routeAction overlaps other routeAction of same partial trip
		if(service.checkEventOverlap(args.event,eventData).length >0)
			return true
		else
			false
	}

	const setProgressBar = (dataId) => {
		if(_.isNil(dataId)){
			let elements = document.getElementsByClassName(Consts.targetClassName);
			for(var i=0; i < elements.length; i++){
				elements[i]?.classList?.remove(Consts.classToAlter);
			}
		} else {
			const dragElement = document.querySelector(`[data-id="${dataId}"]`);
			if (dragElement) {
				const parentElement = dragElement.closest(`.${Consts.targetClassName}`);				
				parentElement.classList.add(Consts.classToAlter);					
				
			}
		}
	}

	const onEventDragEnd = (args,inst)=>{
		if(isEventUpdated.current && currentDraggedEvent.current?.event){
			let _visibleOverlappedEvents = _.cloneDeep(visibleOverlappedEvents);
			let _tmpEventData = eventData

			let hourDiff = service.calculateDuration(args.event.start,currentDraggedEvent.current.event.start)		
			if(!args.event.isRemark && !args.event.isAgendaItem) {
				
				if(viewType == Consts.Movement) {
					setProgressBar(currentDraggedEvent.current?.event.id)
					if(currentDraggedEvent.current.action === 'move') {
						let hourDiff = service.calculateDuration(args.event.start,currentDraggedEvent.current.event.start)
						movementId.forEach((item,i)=>{
							if(item?.id != args.event.routeId){
								let index = [..._tmpEventData,...hiddenOverlappedEvents.current].findIndex((elem)=>  elem.routeId.toLowerCase() == item.id.toLowerCase()) 
								if(index != -1) {
									_tmpEventData[index].start = moment(_tmpEventData[index].start).add(hourDiff,'hours')
									_tmpEventData[index].end = moment(_tmpEventData[index].end).add(hourDiff,'hours')
									onPlanButtonsNetworkCall(getRoutes,null, _tmpEventData[index].routeId,'Microsoft.NAV.moveInTimeLine', service.parseDate(moment(_tmpEventData[index].start).add(hourDiff,'hours'),null,viewType),true);
								} else {
									console.log("index not found")
								}
							} else {							
								const times = service.findMinMaxTimes(movementId,_tmpEventData)
								const tmpEvents = _tmpEventData.filter((item) => item.resource == args.event.resource && item.partialTripId != args.event.partialTripId)							
								const overlappingPartialTripIds = service.findOverlappingRecord(times.minStartTime, times.maxEndTime , tmpEvents);
								let obj = service.parseDate(args.event.start,null,viewType)
								const input = JSON.parse(obj.input);
								if(currentDraggedEvent.current.resource !== args.resource)
								{
									let resourceData = service.findResourceById(myResources, args.resource)
									input.planGroup=resourceData.planGroup
									input.resourceCode=resourceData.resourceNo
								}							
								obj.input = JSON.stringify(input)
								if(overlappingPartialTripIds.length >0){								
									const input = JSON.parse(obj.input);
									input.dropOnPartialTrip = overlappingPartialTripIds[0]								
									obj.input = JSON.stringify(input)
								}
								PlanNewPartialTrip(getRoutes,null,args.event.routeId,'Microsoft.NAV.moveInTimeLine',obj,{},PlanFunctionsForFlag.MoveMovement)
							}				
						})
						_tmpEventData = _.cloneDeep(_tmpEventData)
					}
				} else if (viewType == Consts.PartialTrip) {
					if(currentDraggedEvent.current.action === 'move' && currentDraggedEvent.current?.event?.resource !== args.resource) {
						let resourceData = service.findResourceById(myResources, args.resource)
						let obj = {
							fromAgenda:true,
							resourceType:resourceData.resourceType,
							resourceCode:resourceData.resourceNo,
						}         
						currentonDropEventData.current = args.event
						callAPIChangePtResource(obj)      
					} else if (currentDraggedEvent.current.action === 'move') {
						let newEventData = _tmpEventData.map((item)=> {
							if (item?.partialTripId === args.event.partialTripId) {
								return {
									...item,
									start: moment(item.start).add(hourDiff, 'hours'),
									end: moment(item.end).add(hourDiff, 'hours')
								};
							} else {
								return { ...item };
							}
						})
	
						let events = myEvents.filter(item=> item.isRemark == undefined && item.partialTripId != args.event.partialTripId && item.resource == args.event.resource)
						const overlappingPartialTripIds = service.findOverlappingRecord(args.event.start, args.event.end , events);
						_tmpEventData = newEventData
						callPlanFunctionPostWithIdAPI(getPartialTrip,null,args.event.partialTripId,'Microsoft.NAV.moveInTimeLine', service.parseDate(args.event.start,overlappingPartialTripIds), PlanFunctionsForFlag.ConfirmNewPartialTrip, true, false, i18_en.operationSuccessful);
					}
				} else if (viewType == Consts.Route) {
					setProgressBar(currentDraggedEvent.current?.event.id)
					if (currentDraggedEvent.current.action === 'move' && !changeSeqIcon) {
						if(!manualModeIcon) {
							let newData = _.concat(_tmpEventData,hiddenOverlappedEvents.current).filter((item)=>item?.partialTripId === args.event.partialTripId)
							let found = false;	
							const result = [];
						
							for (const item of newData) {
								if (found) 
									result.push(item.routeId);
								if (item.routeId === args.event.routeId) 
									found = true;
							}
							let newEventData = _tmpEventData.map((item)=> {
								if(result.includes(item.routeId)) {
									onPlanButtonsNetworkCall(getRoutes,null, item.routeId,'Microsoft.NAV.moveInTimeLine', service.parseDate(moment(item.start).add(hourDiff, 'hours'),null,viewType),true);
									return {
										...item,
										start: moment(item.start).add(hourDiff, 'hours'),
										end: moment(item.end).add(hourDiff, 'hours')
									}
								} else if (item.routeId === args.event.routeId) {
									return {
										...item,
										start: moment(item.start).add(hourDiff, 'hours'),
										end: moment(item.end).add(hourDiff, 'hours')
									}
								}else {
									return {...item}
								}
							})
							// const poppedFromVisible = _.remove(visibleOverlappedEvents, item => item.id != args.event.id && !item.hasOverlappedEvents);
							hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.map((item)=> {
								if(result.includes(item.routeId)) {
									onPlanButtonsNetworkCall(getRoutes,null, item.routeId,'Microsoft.NAV.moveInTimeLine', service.parseDate(moment(item.start).add(hourDiff, 'hours'),null,viewType),true);
									return {
										...item,
										start: moment(item.start).add(hourDiff, 'hours'),
										end: moment(item.end).add(hourDiff, 'hours')
									}
								} else {
									return {...item}
								}
							})
							// const poppedFromHidden = _.remove(hiddenOverlappedEvents.current, item => item.id != args.event.id);
							// setTimeout(() => {
								_tmpEventData = newEventData;
							// }, 100);
							onPlanButtonsNetworkCall(getRoutes,null, args.event.routeId,'Microsoft.NAV.moveInTimeLine', service.parseDate(args.event.start,null,viewType),true);
						} else {
							onPlanButtonsNetworkCall(getRoutes,null, args.event.routeId,'Microsoft.NAV.moveInTimeLine', service.parseDate(args.event.start,null,viewType),true);
							// setTimeout(() => {
								_tmpEventData = service.updateEventData(_tmpEventData,args.event.id,{start:args.event.start,end:args.event.end})
							// }, 100);
						}
					} else if (currentDraggedEvent.current.action === 'resize') {
						apiService.postWithId(routes,null,args.event.routeId,'Microsoft.NAV.updateStartDateTime',service.parseDate(args.event.start)).then((response)=>{
							apiService.postWithId(routes,null,args.event.routeId,'Microsoft.NAV.updateEndDateTime',service.parseDate(args.event.end)).then((response)=>{
								})
							})
							_tmpEventData = service.updateEventData(_tmpEventData,args.event.id,{start:args.event.start,end:args.event.end})
					}
				}
				if(window.location.hash.includes("#/CustomView")){
					let obj = {
						tripNumber: args.event.partialTripId,
						// partialTrips: [newEvent],
						guid: props.guid,
						customView: props.customView
					};
					dispatch(setPartialTripReducer(obj));
					dispatch(setRemovePartialTrip(false));
				}
				enableDisableIcon(false)
				setSelectedEvent([args.event])
			} else {
				if (currentDraggedEvent.current.action === 'resize') {
					let obj = {
						"input": JSON.stringify({newStartDateTime:moment(args.event.start).format(process.env.REACT_APP_DATETIMEFORMAT2),newEndDateTime : moment(args.event.end).format(process.env.REACT_APP_DATETIMEFORMAT2)})
					}
					// callPlanFunctionPostWithIdAPI(plannedActions,null,args.event.id,'Microsoft.NAV.resizePlannedAction', obj, null, true, false, i18_en.operationSuccessful);
					apiService.postWithId(plannedActions,null,args.event.id,'Microsoft.NAV.resizePlannedAction',obj).then((response)=>{
						setPlannedAction(service.updateEventData(plannedAction,args.event.id,{start:args.event.start,end:args.event.end}))
					})
				} else if (currentDraggedEvent.current.action === 'move') {
					let obj = {
						"input": JSON.stringify({newDateTime:moment(args.event.start).format(process.env.REACT_APP_DATETIMEFORMAT2),resourceType :args?.event?.resourceData?.resourceType ,resourceCode:args?.event?.resourceData?.resourceNo})
					}
					PlanNewPartialTrip(plannedActions,null,args.event.id,'Microsoft.NAV.movePlannedAction',obj,{data:args.event},PlanFunctionsForFlag.MoveAgendaItem)
					parseEventData(viewType)
					setPlannedAction(service.updateEventData(plannedAction,args.event.id,{start:args.event.start,end:args.event.end}))
				}	
			}

			// Check if the current event is available in visibleOverlappedEvents
			if (_.some(_visibleOverlappedEvents, { id: args.event.id })) {
				let overlappedEvents = _.uniqBy(service.checkEventOverlap(args.event, [..._tmpEventData]), 'id');
				overlappedEvents = _.sortBy(overlappedEvents, 'start');
				
				hiddenOverlappedEvents.current.push(args.event);

				if (overlappedEvents.length > 0) {
					const visibleIds = _visibleOverlappedEvents.map(e => e.id);
					const overlappedIds = overlappedEvents.map(e => e.id);
					
					if (_.some(visibleIds, id => _.includes(overlappedIds, id))) {
					_visibleOverlappedEvents.push(args.event);
					_visibleOverlappedEvents = _.uniqBy(_visibleOverlappedEvents, 'id');
					} else {
					_visibleOverlappedEvents = _visibleOverlappedEvents.filter(e => e.id !== args.event.id);
					}

					hiddenOverlappedEvents.current = _.uniqBy(hiddenOverlappedEvents.current, 'id');

					if (args.event.start < overlappedEvents[0].start) {
					_visibleOverlappedEvents = _visibleOverlappedEvents.filter(event => event.id !== args.event.id);
					hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(event => event.id !== args.event.id);
					
					args.event.hasOverlappedEvents = true;
					const _eventsArr = _.sortBy([args.event, ..._tmpEventData], 'start');
					
					_tmpEventData =  _eventsArr.filter(event => event.id !== overlappedEvents[0].id)

					const updatedEvent = { ...overlappedEvents[0] };
					delete updatedEvent.hasOverlappedEvents;

					_visibleOverlappedEvents = [..._visibleOverlappedEvents, updatedEvent];
					hiddenOverlappedEvents.current.push(updatedEvent);
					}

					setVisibleOverlappedEvents(prev => _.sortBy(_visibleOverlappedEvents, 'start'));

				} else {
					hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(e => e.id !== args.event.id);
					_visibleOverlappedEvents = _visibleOverlappedEvents.filter(e => e.id !== args.event.id);
					_tmpEventData.push(args.event);

					setVisibleOverlappedEvents(_visibleOverlappedEvents);
					// setEventData(_tmpEventData);
				}

			// Check if the current event is available in _tmpEventData
			} else if (_.some(_tmpEventData, { id: args.event.id })) {
				let overlappedFromEventData = _.uniqBy(service.checkEventOverlap(args.event, _tmpEventData.filter(e => e.id !== args.event.id)), 'id');
				let overlappedFromVisibleOverlapped = _.uniqBy(service.checkEventOverlap(args.event, _visibleOverlappedEvents), 'id');
				let oldOverlappedFromVisibleOverlapped = _.uniqBy(service.checkEventOverlap(args.oldEvent, _visibleOverlappedEvents), 'id');

				overlappedFromEventData = _.sortBy(overlappedFromEventData, 'start');
				overlappedFromVisibleOverlapped = _.sortBy(overlappedFromVisibleOverlapped, 'start');
				oldOverlappedFromVisibleOverlapped = _.sortBy(oldOverlappedFromVisibleOverlapped, 'start');

				if (overlappedFromEventData.length > 0) {
					if (args.event.start > overlappedFromEventData[0].start) {
					delete args.event.hasOverlappedEvents;
					_visibleOverlappedEvents.push(args.event);
					hiddenOverlappedEvents.current.push(args.event);

					_tmpEventData = _tmpEventData.filter(e => e.id !== args.event.id);
					_tmpEventData = _.map(_tmpEventData, event => event.id === overlappedFromEventData[0].id
						? { ...event, hasOverlappedEvents: true }
						: event);

					} else {
					delete overlappedFromEventData[0].hasOverlappedEvents;
					_visibleOverlappedEvents.push(overlappedFromEventData[0]);
					hiddenOverlappedEvents.current.push(overlappedFromEventData[0]);

					_tmpEventData = _tmpEventData.filter(e => e.id !== overlappedFromEventData[0].id);
					_tmpEventData = _.map(_tmpEventData, event => event.id === args.event.id
						? { ...event, hasOverlappedEvents: true }
						: event);
					}

				} // push first visibleOverlappedEvent to _tmpEventData if main event is moved and not overlapping
				else if (oldOverlappedFromVisibleOverlapped.length > 0 && !_.some(overlappedFromVisibleOverlapped, { id: oldOverlappedFromVisibleOverlapped[0].id })) {
					oldOverlappedFromVisibleOverlapped[0].hasOverlappedEvents = true;
					_tmpEventData.push(oldOverlappedFromVisibleOverlapped[0]);
					_visibleOverlappedEvents = _visibleOverlappedEvents.filter(e => e.id !== oldOverlappedFromVisibleOverlapped[0].id);
					hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(e => e.id !== oldOverlappedFromVisibleOverlapped[0].id);

				} else if (overlappedFromEventData.length === 0 && overlappedFromVisibleOverlapped.length > 0) {
					if (args.event.start > overlappedFromVisibleOverlapped[0].start) {
					overlappedFromVisibleOverlapped[0].hasOverlappedEvents = true;
					_tmpEventData.push(overlappedFromVisibleOverlapped[0]);
					_tmpEventData = _tmpEventData.filter(e => e.id !== args.event.id);

					delete args.event.hasOverlappedEvents;
					_visibleOverlappedEvents.push(args.event);
					hiddenOverlappedEvents.current.push(args.event);
					}
				}

				// setEventData(_tmpEventData);
				setVisibleOverlappedEvents(_visibleOverlappedEvents);
			}

			setEventData(_tmpEventData)
			setVisibleOverlappedEvents(_visibleOverlappedEvents)
		}
	}
	const onEventUpdate = (args,inst)=>{		
		isEventUpdated.current = true
		if((viewType == Consts.Movement || (viewType == Consts.Route && (manualModeIcon || args.event.start < args.oldEvent.start))) && checkRouteOverlap(args) && !changeSeqIcon ){
			setErrorSnackbarMessage(i18_en.eventOverlapNotAllowed)
			setErrorSnackbarOpen(true)
			isEventUpdated.current = false
			return false
		} else if(!currentDraggedEvent.current){						
			isEventUpdated.current = false
			return false
		}
		if (args.event.isRouteAction && viewType == Consts.Route) {
			if(changeSeqIcon) {
				callPlanFunctionPostWithIdAPI(getRoutes,null,args.event.routeId,'Microsoft.NAV.changeRouteSequence', service.parseDate(args.event.start),PlanFunctionsForFlag.ChangeSequence, true, false, i18_en.operationSuccessful);
			}
		}
	}
	const onEventUpdateFailed = (args,inst)=>{		
		isEventUpdated.current = false
	}
	const onEventUpdated =(args,inst)=>{
		// // console.log("onEventUpdated")
		// let _visibleOverlappedEvents = _.cloneDeep(visibleOverlappedEvents);
		// let _tmpEventData = eventData

		// // Check if the current event is available in visibleOverlappedEvents
		// if (_.some(visibleOverlappedEvents, { id: args.event.id })) {
		// 	let overlappedEvents = _.uniqBy(service.checkEventOverlap(args.event, [...eventData]), 'id');
		// 	overlappedEvents = _.sortBy(overlappedEvents, 'start');
			
		// 	hiddenOverlappedEvents.current.push(args.event);

		// 	if (overlappedEvents.length > 0) {
		// 		const visibleIds = visibleOverlappedEvents.map(e => e.id);
		// 		const overlappedIds = overlappedEvents.map(e => e.id);
				
		// 		if (_.some(visibleIds, id => _.includes(overlappedIds, id))) {
		// 		_visibleOverlappedEvents.push(args.event);
		// 		_visibleOverlappedEvents = _.uniqBy(_visibleOverlappedEvents, 'id');
		// 		} else {
		// 		_visibleOverlappedEvents = _visibleOverlappedEvents.filter(e => e.id !== args.event.id);
		// 		}

		// 		hiddenOverlappedEvents.current = _.uniqBy(hiddenOverlappedEvents.current, 'id');

		// 		if (args.event.start < overlappedEvents[0].start) {
		// 		_visibleOverlappedEvents = _visibleOverlappedEvents.filter(event => event.id !== args.event.id);
		// 		hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(event => event.id !== args.event.id);
				
		// 		args.event.hasOverlappedEvents = true;
		// 		const _eventsArr = _.sortBy([args.event, ...eventData], 'start');
				
		// 		setEventData(prev => _eventsArr.filter(event => event.id !== overlappedEvents[0].id));

		// 		const updatedEvent = { ...overlappedEvents[0] };
		// 		delete updatedEvent.hasOverlappedEvents;

		// 		_visibleOverlappedEvents = [..._visibleOverlappedEvents, updatedEvent];
		// 		hiddenOverlappedEvents.current.push(updatedEvent);
		// 		}

		// 		setVisibleOverlappedEvents(prev => _.sortBy(_visibleOverlappedEvents, 'start'));

		// 	} else {
		// 		hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(e => e.id !== args.event.id);
		// 		_visibleOverlappedEvents = _visibleOverlappedEvents.filter(e => e.id !== args.event.id);
		// 		_tmpEventData.push(args.event);

		// 		setVisibleOverlappedEvents(_visibleOverlappedEvents);
		// 		setEventData(_tmpEventData);
		// 	}

		// // Check if the current event is available in eventData
		// } else if (_.some(eventData, { id: args.event.id })) {
		// 	let overlappedFromEventData = _.uniqBy(service.checkEventOverlap(args.event, eventData.filter(e => e.id !== args.event.id)), 'id');
		// 	let overlappedFromVisibleOverlapped = _.uniqBy(service.checkEventOverlap(args.event, visibleOverlappedEvents), 'id');
		// 	let oldOverlappedFromVisibleOverlapped = _.uniqBy(service.checkEventOverlap(args.oldEvent, visibleOverlappedEvents), 'id');

		// 	overlappedFromEventData = _.sortBy(overlappedFromEventData, 'start');
		// 	overlappedFromVisibleOverlapped = _.sortBy(overlappedFromVisibleOverlapped, 'start');
		// 	oldOverlappedFromVisibleOverlapped = _.sortBy(oldOverlappedFromVisibleOverlapped, 'start');

		// 	if (overlappedFromEventData.length > 0) {
		// 		if (args.event.start > overlappedFromEventData[0].start) {
		// 		delete args.event.hasOverlappedEvents;
		// 		_visibleOverlappedEvents.push(args.event);
		// 		hiddenOverlappedEvents.current.push(args.event);

		// 		_tmpEventData = _tmpEventData.filter(e => e.id !== args.event.id);
		// 		_tmpEventData = _.map(_tmpEventData, event => event.id === overlappedFromEventData[0].id
		// 			? { ...event, hasOverlappedEvents: true }
		// 			: event);

		// 		} else {
		// 		delete overlappedFromEventData[0].hasOverlappedEvents;
		// 		_visibleOverlappedEvents.push(overlappedFromEventData[0]);
		// 		hiddenOverlappedEvents.current.push(overlappedFromEventData[0]);

		// 		_tmpEventData = _tmpEventData.filter(e => e.id !== overlappedFromEventData[0].id);
		// 		_tmpEventData = _.map(_tmpEventData, event => event.id === args.event.id
		// 			? { ...event, hasOverlappedEvents: true }
		// 			: event);
		// 		}

		// 	} // push first visibleOverlappedEvent to eventData if main event is moved and not overlapping
		// 	else if (oldOverlappedFromVisibleOverlapped.length > 0 && !_.some(overlappedFromVisibleOverlapped, { id: oldOverlappedFromVisibleOverlapped[0].id })) {
		// 		oldOverlappedFromVisibleOverlapped[0].hasOverlappedEvents = true;
		// 		_tmpEventData.push(oldOverlappedFromVisibleOverlapped[0]);
		// 		_visibleOverlappedEvents = _visibleOverlappedEvents.filter(e => e.id !== oldOverlappedFromVisibleOverlapped[0].id);
		// 		hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(e => e.id !== oldOverlappedFromVisibleOverlapped[0].id);

		// 	} else if (overlappedFromEventData.length === 0 && overlappedFromVisibleOverlapped.length > 0) {
		// 		if (args.event.start > overlappedFromVisibleOverlapped[0].start) {
		// 		overlappedFromVisibleOverlapped[0].hasOverlappedEvents = true;
		// 		_tmpEventData.push(overlappedFromVisibleOverlapped[0]);
		// 		_tmpEventData = _tmpEventData.filter(e => e.id !== args.event.id);

		// 		delete args.event.hasOverlappedEvents;
		// 		_visibleOverlappedEvents.push(args.event);
		// 		hiddenOverlappedEvents.current.push(args.event);
		// 		}
		// 	}

		// 	setEventData(_tmpEventData);
		// 	setVisibleOverlappedEvents(_visibleOverlappedEvents);
		// }
	}
	const onEventClick = (args,inst)=>{	
		if(!args?.event?.isRouteAction) {
			setShowTimelineContextMenu(false)
			setSelectedEvent([])
			enableDisableIcon(true)
			const obj = {
				tripNumber: 0,
				partialTrips: [],
				guid: props.guid,
				customView: props.customView
			};
			dispatch(setPartialTripReducer(obj));
			dispatch(setRemovePartialTrip(true));
		}
	}
	const onShowHideOverlappedEvents = (event)=>{
		if(event.hasOverlappedEvents){
			setTooltipOpen(false)
			const overlappingIds = service.checkEventOverlap(event, [...eventData, ...hiddenOverlappedEvents.current]).map(event => event.id);
    		const visibleOverlappedIds = visibleOverlappedEvents.map(event => event.id);
			const isEventsVisible = visibleOverlappedIds.some(id => overlappingIds.includes(id))
			let tmpVisibleOverlappedEvents = []
			if(isEventsVisible){
				const relatedOverlappedEvents = _.filter(
					visibleOverlappedEvents,
					(e) => !overlappingIds.includes(e.id)
				);
				tmpVisibleOverlappedEvents = relatedOverlappedEvents
			}else{
				const relatedOverlappedEvents = service.checkEventOverlap(event,[...eventData,hiddenOverlappedEvents.current])
				tmpVisibleOverlappedEvents = _.uniqBy(_.concat(visibleOverlappedEvents,relatedOverlappedEvents),'id')
				
			}
			tmpVisibleOverlappedEvents = tmpVisibleOverlappedEvents.map(ele => ({
				...ele,
				isRouteAction: true,
				editable : !ele?.fixedActionTime
			}));
			setVisibleOverlappedEvents(tmpVisibleOverlappedEvents)
			setEventData([...eventData])
		}
	}
	const onEventDoubleClick = (e)=>{
		setSelectedEvent([e?.event])
		if(e?.event?.isRemark || e?.event?.isAgendaItem)
			onPlanButtons('show-details action item/ remark', e.event.id, {event:e})
	}
	const onResourceDrop = (e, resource, dragData) => {
        if (drageItems.source == 'partialTrips' && gridFlagVal=='agendaView') {
			let obj = {
				"input": JSON.stringify({planGroup:resource?.planGroup,resourceCode : resource?.resourceNo})
			}
			PlanNewPartialTrip(getPartialTrip,null,drageItems?.items[0]?.id,'Microsoft.NAV.planOnAgenda',obj,{},PlanFunctionsForFlag.PlanPartialTripOnAgenda)
        } else if (drageItems.source == 'movements' && gridFlagVal=='agendaView') {	
			if([Consts.VEHICLES,Consts.TRAILERS,Consts.DRIVERS,Consts.CONTAINERS].includes(iconActive)) {
				const actualSelectedIds = drageItems.items.map(e => e.id);
				if (actualSelectedIds) {
					const movementObjects = service.movementObject(actualSelectedIds, drageItems.source);					
					let startDateTime = new Date(selectedDate)
					startDateTime.setHours(0, 0, 0, 0);
					let inputTripDataObject = {
						fromAgenda : true,
						startDateTime : moment(startDateTime).format(process.env.REACT_APP_DATETIMEFORMAT2),
						endDateTime : moment(startDateTime).add(days, 'days').format(process.env.REACT_APP_DATETIMEFORMAT2),
						planGroup : resource?.planGroup,
						resourceCode : resource?.resourceNo
					}
					const obj = service.movementLinesAndOperationDeatilObject(movementObjects, JSON.stringify(inputTripDataObject), gridFlagVal);
					postPlanMovementsAPI(obj,movementObjects)
				}
			}
        }
        resetDragEvent()
    }
	const postPlanMovementsAPI = (obj, movementObjects) => {
		apiService.post(planMovementsNew,obj).then(response => {
			if (response !== null && response !== undefined) {
				if (response.error !== null && response.error !== undefined && response.error) {
					setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
				} else {
					const result = JSON.parse(response?.operationDetail[0]?.result);
					const successMessage = result?.drillDownMessage ? result?.drillDownMessage : i18_en.tripCreatedSuccessfully;
					const drillDownURL = result?.drillDownUrl ? result?.drillDownUrl : '';
					if (service.apiResultChecker(result)) {
						const param = {
							title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
							for: PlanFunctionsForFlag.PlanMovementsNewNotification,
							parameters: result.parameters
						};
						setopenConfirmationModal(true);
						setCommonPopupParameters(param);
						if (service.apiOKResultChecker(result)) {
							setSuccessSnackbarAndMessage(successMessage);
							setDrillDownFlagAndURL(false, drillDownURL);
							setopenConfirmationModal(false)
							sendDataToParent(true, 'refresh');
							dispatch(setPlannedOnAgendaMovement(true))
							dispatch(refreshMovement({ isRefresh: true }));
						}
					} else if (result?.parameters && (result.parameters[0]?.type === 'Dialog.ConfirmSingleLine' || result.parameters[0]?.type === 'Dialog.SelectRadioButton' || result.parameters[0]?.type === 'Edm.DateTime')) {
						const input = response?.operationDetail[0]?.input ? JSON.parse(response?.operationDetail[0]?.input) : null;
						const param = {
							movementlines: movementObjects,
							title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
							for: PlanFunctionsForFlag.PlanMovementsOnAgenda,
							parameters: result.parameters,
							data : result?.data,
							input: input,
							obj : obj
						};
						setopenConfirmationModal(true);
						setCommonPopupParameters(param);
					} else if(result?.parameters && (result.parameters[0]?.type === 'APIGrid')) {
						const input = response?.operationDetail[0]?.input ? JSON.parse(response?.operationDetail[0]?.input) : null;
						const param = {
							movementlines: movementObjects,
							title: "Select Partial Trip",
							for: PlanFunctionsForFlag.PlanMovementsOnAgenda,
							parameters: result?.parameters[0]?.restrictions?.Group?.values,
							data : result?.data,
							input: input,
							obj : obj
						};
						setCommonPopupParameters(param);
						setOpenModalPopUp(true)
					} else {
						if (service.apiOKResultChecker(result)) {
							setSuccessSnackbarAndMessage(successMessage);
							setDrillDownFlagAndURL(false, drillDownURL);
							setopenConfirmationModal(false);
							sendDataToParent(true, 'refresh');
							dispatch(setPlannedOnAgendaMovement(true))
							dispatch(refreshMovement({ isRefresh: true }));
						}
					}
				}
			}
		})
	}
	const resetDragEvent = () => {
        const obj = {
            source: '',
            destination: '',
            eventType: '',
            isTripGenerated: false,
            items: {}
        }
        dispatch(drageItemsReducer(obj))
    }
	const renderCustomResource = (resource) => {
        const clickResourceCheckBox = (resourceId) => (event) => {
            if (event.target.checked && !checkedResource.includes(resourceId)) {
                setCheckedResource(prev => [...prev, resourceId]);
            } else {
                setCheckedResource(prev => prev.filter(id => id !== resourceId));
            }
        }
		const handleKey = (e) => { 
            const key = e.charCode || e.keyCode; 
            if (key === 39 || key === 37) { 
                   const resUpd = [...myResources]; 
                   const found = resUpd.find((f) => f.id === resource.id); 
                   if (found) { 
                           found.collapsed = key === 37; 
                           setMyResources(resUpd); 
                    } 
              } 
         }; 
        return (
			<>
				{!resource.isParent && (
					<div
						className="md-resource-header-template-cont d-flex"
						style={{ height: "100%", width: "100%" }}
						onDragOver={(e) => {
							e.preventDefault();
						}}
						onDrop={(e) => onResourceDrop(e, resource, drageItems)}
						onContextMenu={(e) => onCellRightClick(e, resource)}
					>
						<div className="list-col d-flex align-items-center">
							<div
								className="trucklogo"
								style={{ justifyContent: "left", marginRight: "5px" }}
							>
								<div className="d-flex flex-row">
									{iconActive == Consts.VEHICLES && (
										<TruckResource resource={resource} handleEventHoverIn={handleEventHoverIn} handleEventHoverOut={handleEventHoverOut} toggleOpenMail={toggleOpenMail} openMail={openMail} handleDragStart={handleDragStart} nvtVehicleType={nvtVehicleType.current} nvtQualificationType={nvtQualificationType.current}/>
									)}
									{(iconActive == Consts.TRAILERS || iconActive == Consts.CHASSIS) && (
										<TrailerResource resource={resource} handleEventHoverIn={handleEventHoverIn} handleEventHoverOut={handleEventHoverOut} toggleOpenMail={toggleOpenMail} openMail={openMail} handleDragStart={handleDragStart} nvtTrailerType={nvtTrailerType.current} nvtQualificationType={nvtQualificationType.current}/>
									)}
									{iconActive == Consts.DRIVERS && (
										<DriverResource resource={resource} toggleOpenMail={toggleOpenMail} openMail={openMail} handleDragStart={handleDragStart} />
									)}
									{/* {iconActive == Consts.CHASSIS && (
										<ChassisResource resource={resource} toggleOpenMail={toggleOpenMail} openMail={openMail} handleDragStart={handleDragStart} />
									)} */}
									{iconActive == Consts.CONTAINERS && (
										<ContainerResource resource={resource} toggleOpenMail={toggleOpenMail} openMail={openMail} handleDragStart={handleDragStart} />
									)}
									{iconActive == Consts.VARIOUS && (
										<VariousResource resource={resource} toggleOpenMail={toggleOpenMail} openMail={openMail} handleDragStart={handleDragStart} />
									)}
								</div>
							</div>
						</div>
						<span className="list-checkbox ml-auto pnl-checkbox">
							<Checkbox
								key={resource.id}
								checked={checkedResource.some(
									(item) => item.id === resource.id
								)}
								onClick={clickResourceCheckBox(resource)}
							/>
						</span>
					</div>
				)}
				{resource.isParent && (
					<div onKeyDown={handleKey} tabIndex={0}>
						<span>{resource.name}</span>
					</div>
				)}
			</>
        );
    }
	const customHeader = ()=>{
		return (
			<div className="custom-buttons">
				<CalendarPrev />
				<CalendarToday />
				<CalendarNext />
			</div>
		)
	}
	const checkResourceIcon = () => {
		if(checkedResource.length === 1)
			setDisableResourceIcon(false)
		else 
			setDisableResourceIcon(true)
	}
	const disableAllPlanActions = ()=>{
		setDisablePTCOIcon(true)
		setDisableReportIcon(true)
		setDisableResourceIcon(true)		
	}
	const onShortcutKeyPress = (event) => {
		const toggleconfigActionsList = toggleconfigActions?.map(item => item.title);
		// routeIdAction.includes(
		const selectedRouted = getSelectedRoute();
		const selectedValues = getSelectedValues()
		if ((toggleconfigcheckboxesplan['Fixed'] || toggleconfigActionsList.includes('Fixed')) && !disableReportIcon && (event.key.toLowerCase() === 'f')) {
			onPlanButtons('fixed', selectedRouted);
		} else if ((toggleconfigcheckboxesplan['Send To OBC'] || toggleconfigActionsList.includes('Send To OBC')) && !disableReportIcon && (event.altKey && event.key.toLowerCase() === 's')) {
			onPlanButtons('send-to obc', selectedValues);
		} else if ((toggleconfigcheckboxesplan['Contract Out'] || toggleconfigActionsList.includes('Contract Out')) && !disablePTCOIcon && (event.altKey && event.key.toLowerCase() === 'c')) {
			onPlanButtons('contract-out', selectedValues);
		} else if ((toggleconfigcheckboxesplan['Report'] || toggleconfigActionsList.includes('Report')) && !disableReportIcon && (event.altKey && event.key.toLowerCase() === 'r')) {
			onPlanButtons('reports', selectedValues);
		} else if ((toggleconfigcheckboxesplan['Calculate'] || toggleconfigActionsList.includes('Calculate')) && !disableReportIcon && (event.altKey && event.key === 'F7')) {
			onCalculateIconClick(selectedValues);
		} else if ((toggleconfigcheckboxesplan['Manual Mode'] || toggleconfigActionsList.includes('Manual Mode')) && (event.altKey && event.key.toLowerCase() === 'm')) {
			if(selectedValues != "")
				onPlanButtons('manual-mode', selectedValues);
		} else if (event.altKey && event.key === 'F3') {
			onChange('viewType',Consts.Movement)
			setSelectedEvent([])
			disableAllPlanActions()
			parseEventData(Consts.Movement)
		} else if (event.altKey && event.key === 'F2') {
			onChange('viewType',Consts.Route)
			setSelectedEvent([])
			disableAllPlanActions()
			parseEventData(Consts.Route)
		} else if (event.altKey && event.key === 'F5') {
			onChange('viewType',Consts.PartialTrip)
			setSelectedEvent([])
			disableAllPlanActions()
			parseEventData(Consts.PartialTrip)
		} else if (event.altKey && event.key.toLowerCase() === 'm') {
			onPlanButtons('manual-mode')
		} else if (event.altKey && event.key === "Delete") {
			onPlanButtons('delete-partial trip', selectedValues);
		}
	}
	const updateOverlappedEvents = (data) => {
		const overlappingEvents = [];

		data = data.map(event => {
			// delete the hasOverlappedEvents property
			const { hasOverlappedEvents, ...rest } = event;
			return rest;
		});
		
		_.forEach(data, (curEvent, i) => {
		  // Find events with the same partialTripId and start time (excluding the current one)	
		let overlappingWithVisible = _.cloneDeep( _.uniqBy(service.checkEventOverlap(curEvent,visibleOverlappedEvents),'id'))
		overlappingWithVisible = _.sortBy(overlappingWithVisible, 'start')
		// if(overlappingWithVisible.length > 0){
		// 	debugger
		// 	if(overlappingWithVisible[0].start > curEvent.start){
		// 		setVisibleOverlappedEvents(prev =>
		// 			prev.filter(event => event.id !== overlappingWithVisible[0].id)
		// 		);
				
		// 		hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter(
		// 		event => event.id !== overlappingWithVisible[0].id
		// 		);
		// 		overlappingWithVisible[0].hasOverlappedEvents = true;
		// 		setTimeout(()=>{
		// 			setEventData(prev => [...prev, overlappingWithVisible[0]]);

		// 			// Remove curEvent from eventData
		// 			setEventData(prev =>
		// 				prev.filter(event => event.id !== curEvent.id)
		// 			);
		// 		},200)
				
		// 		const updatedEvent = { ...curEvent };
		// 		delete updatedEvent.hasOverlappedEvents;

		// 		setVisibleOverlappedEvents(prev => [...prev, updatedEvent]);
		// 		hiddenOverlappedEvents.current.push(updatedEvent);
		// 	}
		// }
		const overlapping = _.cloneDeep( _.uniqBy(service.checkEventOverlap(curEvent,data),'id'))
		  if (overlapping.length > 0) {
			// Mark the first curEvent with flags if not already marked
			if (!curEvent.isOverlappedEventVisible && !curEvent.hasOverlappedEvents) {
			  curEvent.hasOverlappedEvents = true;
			}
			// Remove overlapping events from the main array and push them into overlappingEvents array
			overlapping.forEach((overlappedEvent, index) => {
			  	const removedEvent = _.remove(data, (e) => e.id === overlappedEvent.id);
				overlappingEvents.push(...removedEvent);				
			});
		  }else{
			setVisibleOverlappedEvents([...visibleOverlappedEvents].filter((ele)=> ele?.routeId != curEvent?.routeId))		
			hiddenOverlappedEvents.current = hiddenOverlappedEvents.current.filter((ele)=> ele?.routeId != curEvent?.routeId)
		  }
		});	
		// Store the overlapped events in a separate array or use them elsewhere				
		hiddenOverlappedEvents.current = _.uniqBy(overlappingEvents,'id');
	  
		return data;
	  };
	  
	const  parseEventData = (flag) => {
		
        if (flag == Consts.PartialTrip) {
			const data = Object.groupBy(eventData, ({ partialTripId }) => partialTripId);
            const groupedDataArray = Object.entries(data).map(([key, value]) => {
				value = _.sortBy(value, ['start']);
				const endIndex = value.length - 1;
				const fixedActionTime = value.every(item => item.fixedActionTime);
				
				return {
				  partialTripId: key,
				  tripNo: value[0].tripNo,
				  data: value,
				  start: value[0].start,
				  end: value[endIndex].end,
				  resource: value[0].resource,
				  fixedActionTime: fixedActionTime,
				  id: key,
				  editable:!fixedActionTime,
				  resize:false,
				  isRouteAction:true
				//   resize: !fixedActionTime,
				//   dragInTime: !fixedActionTime,
				//   dragBetweenResources: !fixedActionTime,
				};
			  });
			//   const newArray = _.sortBy(_.union(groupedDataArray), ['partialTripId','start'])
			  setMyEvents([...plannedAction, ...groupedDataArray]);
			  
        } else if (flag == Consts.Route || flag == Consts.Movement) {			
			const startDateTime = new Date(new Date(selectedDate).setHours(0,0,0,0,0))
			const endDateTime = moment(startDateTime).add(days, 'days').toDate();

			if(flag == Consts.Movement)
				eventData.map(e => e.resize = false)
			else
				eventData.map(e => e.resize = true)

			const outOfTimeEvents = _.uniqBy(eventData.filter(e => new Date(e?.end) > endDateTime), 'partialTripId');
			const inTimeEvents = eventData.filter(e => new Date(e?.end) < endDateTime);

			const eventsToAdd = outOfTimeEvents.map(e => ({
				resource: e.resource,
				resourceNo: e.resourceNo,
				partialTripId: e.partialTripId,
				tripNo: e.tripNo,
				id: guid(),
				start: moment(endDateTime).subtract(3, 'minutes').toDate(),
				end: moment(endDateTime).subtract(2, 'minutes').toDate(),
				editable: false,
				isoutOfTimeEvent: true
			}));

			let _preProcessedEvents = _.chain([...inTimeEvents, ...eventsToAdd])
			.filter(item => item.start && item.partialTripId)
			.sortBy(['resource', 'partialTripId', 'start'])
			.value();
			
			_preProcessedEvents = updateOverlappedEvents([..._preProcessedEvents,...visibleOverlappedEvents])					
			let _dummyEvents = []
			let _processedEvents = [];
			let _groupedTmpEvents = _.groupBy(_preProcessedEvents, 'resource');
			let _tmpEventKeys = Object.keys(_groupedTmpEvents);
			
			_tmpEventKeys?.map((resourceId)=>{
				let _soretedPtrByResource = _.sortBy(service.getSimplified_F_L_Events(_groupedTmpEvents[resourceId]),['firstDateTime', 'partialTripId'])
				let _linewisePtrByResource = [];
				let _tmpObjForLines = {};
				let _tmpLineNo = 1

				_soretedPtrByResource.forEach((baseElement, index) => {
					const _isExists = _linewisePtrByResource.find(e => e.partialTripId == baseElement.partialTripId);
					if(_isExists){
						return;
					}
					_tmpObjForLines = {...baseElement, lineNo: _tmpLineNo }
					_linewisePtrByResource.push(_tmpObjForLines)
					const _subArray = _soretedPtrByResource.filter(e => !_linewisePtrByResource.some(x => x.partialTripId == e.partialTripId));
					_subArray.forEach((subElement, index) => {
						if(baseElement.partialTripId == subElement.partialTripIds){
							return;
						}
						if(_tmpObjForLines.lastDateTime < subElement.firstDateTime){						
							const _tmpSubObjForLines = {...subElement, lineNo: _tmpLineNo };
							_linewisePtrByResource.push(_tmpSubObjForLines);
							_tmpObjForLines = _tmpSubObjForLines;
						}
					});
					_tmpLineNo++;
				});

				_processedEvents = _.union(_processedEvents, _linewisePtrByResource)				
			});
			if(_processedEvents.length > 0){
				let _groupedProcessedEvents = _.groupBy(_processedEvents, 'resource');
				let _eventKeys = Object.keys(_groupedProcessedEvents);
				_eventKeys?.map((key)=>{
					let _groupByLines = _.groupBy(_groupedProcessedEvents[key], 'lineNo');
					let _lines = Object.keys(_groupByLines);
					_lines?.map((line)=>{
						let _startDate = startDateTime;
						let _endDate = endDateTime;
						let _resource = '';
						let _partialTripId = '';
						const _lineCount = _groupByLines[line].length;
						for(var i = 0; i <= _lineCount; i++){
							if (i == _lineCount) {
								_startDate = _groupByLines[line][i -1].lastDateTime;
								_endDate = endDateTime;
								_resource = _groupByLines[line][i -1]?.resource;
								_partialTripId =  _groupByLines[line][i-1]?.partialTripId;
							} else if(i == 0) {
								_startDate = startDateTime;
								_endDate = _groupByLines[line][i].firstDateTime;								
								_resource = _groupByLines[line][i]?.resource;
								_partialTripId =  _groupByLines[line][i]?.partialTripId;
							} else  {
								_startDate = _groupByLines[line][i-1].lastDateTime;
								_endDate = _groupByLines[line][i].firstDateTime;
								_resource = _groupByLines[line][i]?.resource;
								_partialTripId =  _groupByLines[line][i]?.partialTripId;
							}
							_dummyEvents.push({
								id:guid(),
								resource: _resource,
								partialTripId: _partialTripId,
								start: _startDate,
								end : _endDate,
								isExtraDummyEvent : true,
								editable : false,
								lineNo: line
								// order : 1
							});
						}
					});

					_groupedProcessedEvents[key]?.map((_paritalTrip)=>{
						let _ptrId = _paritalTrip?.partialTripId;
						if (!_.isNil(_ptrId)){
							let _allPtrEvents = _.sortBy(_preProcessedEvents.filter(e => e.partialTripId == _ptrId), 'start');
							// _.sortBy(_preProcessedEvents.filter(e => e.partialTripId == _ptrId), x => _.findIndex(_processedEvents, y => x.partialTripId === y.partialTripId))
							_allPtrEvents.reduce((acc, curAction, i) => {
								const nextAction = _allPtrEvents[i + 1];
				
								curAction.editable = !curAction?.fixedActionTime;
								curAction.isRouteAction = true
								curAction.overlap  = true;

								if (nextAction && curAction.partialTripId === nextAction.partialTripId && curAction.resource === nextAction.resource && curAction.end < nextAction.start
									) {
									_dummyEvents.push({
										id:guid(),
										resource: curAction.resource,
										start: curAction.end,
										end : nextAction.start,
										isDummyEvent : true,
										from: curAction.id,
										to: nextAction.id,
										color: service.getConnectionColor(curAction.actionCode),
										editable : false,
										arrow: "",
										partialTripId : curAction.partialTripId,
										lineNo: _processedEvents?.find( e=> e.partialTripId == curAction.partialTripId)?.lineNo
										// cssClass: curAction.actionCode === Consts.LOAD ? "dashed-line" : ''
									});
								}
				
								return acc;
							}, []);
						}
					});
				});
			}
			
			_preProcessedEvents.map(_event => {
				_event.lineNo = _processedEvents?.find( e=> e.partialTripId == _event.partialTripId)?.lineNo;
			});

			const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

			if (isFirefox) {
				let arr = _.orderBy([..._dummyEvents, ..._preProcessedEvents],['lineNo', 'partialTripId', 'start'], ['asc','desc','desc']);
				arr.map(_event => {
					// _event.lineNo = _processedEvents?.find( e=> e.partialTripId == _event.partialTripId)?.lineNo;
					_event.start = new Date(_event.start);
					_event.end = new Date(_event.end);
				});
				setMyEvents(_.uniqBy([...arr, ...visibleOverlappedEvents, ...plannedAction], 'id'));
			} else {				
				let arr = _.orderBy([..._dummyEvents, ..._preProcessedEvents],['lineNo', 'partialTripId', 'start'], ['desc','asc','asc']);
				arr.map(_event => {
					_event.start = new Date(_event.start);
					_event.end = new Date(_event.end);
				});
				setMyEvents(_.uniqBy([...plannedAction, ...visibleOverlappedEvents, ...arr], 'id'));


				// let arr = _.orderBy([..._dummyEvents, ..._preProcessedEvents],['lineNo', 'partialTripId'], ['asc','desc']);
				

				// console.log(arr)
				// setMyEvents(_.uniqBy([...plannedAction, ...visibleOverlappedEvents, ...arr], 'id'));
			}

			// // Preprocess line numbers for _preProcessedEvents
			// _preProcessedEvents.forEach(_event => {
			// 	_event.lineNo = _processedEvents?.find(e => e.partialTripId === _event.partialTripId)?.lineNo;
			// });

			// const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

			// // Combine events and sort
			// const combinedEvents = [..._dummyEvents, ..._preProcessedEvents];
			// const sortOrder = isFirefox ? ['lineNo', 'partialTripId', 'start'] : ['lineNo', 'partialTripId', 'start'];
			// const sortDirections = isFirefox ? ['asc', 'desc', 'desc'] : ['desc', 'asc', 'asc'];

			// let sortedEvents = _.orderBy(combinedEvents, sortOrder, sortDirections);

			// // Map through sorted events to convert start and end to Date
			// sortedEvents.forEach(_event => {
			// 	_event.start = new Date(_event.start);
			// 	_event.end = new Date(_event.end);
			// });

			// // Merge events and remove duplicates
			// const mergedEvents = _.uniqBy([...sortedEvents, ...visibleOverlappedEvents, ...plannedAction], 'id');
			// setMyEvents(mergedEvents);

			setTimeout(() => {
				setProgressBar(null);
			}, 50);
        }
    }
	const dropOnScheduleEvent = (e,eventsData)=>{
		if(drageItems.source == 'agenda' && drageItems.destination == 'agenda'){
			let obj = {
				fromAgenda:true,
				resourceType:drageItems.items.resourceType,
				resourceCode:drageItems.items.resourceNo,
			}         
			currentonDropEventData.current = eventsData
			callAPIChangePtResource(obj)            
        }
	}
	const onEventHoverIn = (args,inst)=>{
		currentHoverEvent.current = {args,inst}		
	}
	const onShowEventTooltip = ()=>{
		const {args,inst} = currentHoverEvent.current
		const overlappingIds = service.checkEventOverlap(args.event, [...myEvents, ...hiddenOverlappedEvents.current]).map(event => event.id);
    	const visibleOverlappedIds = visibleOverlappedEvents.map(event => event.id);		
		if(args.event.hasOverlappedEvents && visibleOverlappedIds.some(id => overlappingIds.includes(id)))
			props?.handleEventHoverIn(args,inst)
		else if(!args.event.hasOverlappedEvents)
			props?.handleEventHoverIn(args,inst)
		else
			return
	}
	useEffect(()=>{
		const viewsData = localStorage.getItem(entity + "Savedview");
		let updatedViews = viewsData ? JSON.parse(viewsData) : initialSavedViewObj;
		getReadLinkData(updatedViews, initialFetchReadLinkData);
	},[initialFetchReadLinkData])
    useEffect(() => {
		const handleClickOutside = (e) => {
			e.preventDefault();
			if (showTimelineContextMenu) {
				setShowTimelineContextMenu(false);
			}
		};			
	
		const handleDragOver = (e) => {
			e.preventDefault();
			setShowTimelineContextMenu(false);
		};
	
		document.addEventListener("click", handleClickOutside);
		document.addEventListener("scroll", handleClickOutside, true); 
		document.addEventListener("dragover", handleDragOver);
	
		return () => {
			document.removeEventListener("click", handleClickOutside);
			document.removeEventListener("scroll", handleClickOutside, true);
			document.removeEventListener("dragover", handleDragOver);
		};
	}, [showTimelineContextMenu]);
	
	useEffect(()=>{
		checkResourceIcon();
	},[checkedResource])
	useEffect(()=>{
		setCheckedResource([])
		setSelectedEvent([])
		disableAllPlanActions()
	},[iconActive])
	useEffect(()=>{		
		setSelectedEvent([])
		disableAllPlanActions()
		parseEventData(viewType)
		setTooltipOpen(false)
	},[viewType])
	useEffect(()=>{	
		const enumCaptions = dataService.getLocalStorageData('enumCaptions') ? JSON.parse(dataService.getLocalStorageData('enumCaptions')) : [];
		nvtVehicleType.current = enumCaptions.find(e => e.entityName === 'nvtVehicleType')?.values || [];
		nvtTrailerType.current = enumCaptions.find(e => e.entityName === 'nvtTrailerType')?.values || [];		
		nvtQualificationType.current = enumCaptions.find(e => e.entityName === 'nvtQualificationType')?.values || [];		
	},[])
	useEffect(()=>{	
		setPlannedAction(props?.plannedAction)
		setEventData([...props?.eventData])		
		setMyResources(props.myResources)
	},[props?.eventData,props?.plannedAction,props.myResources])
	useEffect(()=>{	
	// setTimeout(()=>{
		parseEventData(viewType)
	// },1000)
	},[eventData,plannedAction])
	useEffect(() => {
		document.addEventListener('keydown', onShortcutKeyPress);
		// Remove event listener when the component unmounts
		return () => {
		  document.removeEventListener('keydown', onShortcutKeyPress);
		};
	}, [onShortcutKeyPress])
	return (
		<>
			{/* {isLoading ? (<Spinner minHeight="calc(100vh - 106px)" width="calc(100vw - 206px)" right='0' left="inherit" top="96px" />) : (<></>)} */}
			{isShow && (
				<Grid item={true} component={Card} elevation={0} width={250} square className='overflow-datafix' sx={{ backgroundColor: 'info.light' }}>
					<CardContent sx={{ padding: 0 }}>
						<Box sx={{ flexGrow: 0, p: 1, backgroundColor: 'info.light', marginBottom: 0 }}>
							<div>
								<Accordion className="mui-acc" sx={{ boxShadow: 0 }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
									<AccordionDetails sx={{ padding: 0 }}>
										<Box sx={{ flexGrow: 0, p: 0, backgroundColor: 'info.light', marginBottom: 1 }}>
											<Stack spacing={1} sx={{}}>
												{prtFilterComponents.map((component, index) => {
													return (
														<Box key={index} sx={{ justifyContent: 'center' }}>
															<Stack direction="row" spacing={1} sx={{ display: "flex", alignItems: "center",justifyContent:'space-between' }}>
																<Typography variant="body2" sx={{ pr: 0 }}>{component.label} </Typography>
																{component.type === 'DateTimePicker' && (
																	<Stack direction="column" spacing={1} sx={{ display: "flex", alignItems: "left", justifyContent: 'space-between' }}>
																		<Typography variant="body2" sx={{ pr: 0 }}>{component.placeholder} </Typography>
																		<DateTimePicker
																			showIcon
																			selected={selectedDate}
																			format={process.env.REACT_APP_DATETIMEFORMAT}
																			minDate={minDate}
																			maxDate={maxDate}
																			defaultValue={selectedDate}
																			value={selectedDate}
																			onChange={(value) => onChange(component.key, value)}
																		/>
																	</Stack>
																)}
															{component.type === 'NumericTextBox' && (
																<NumericTextBox
																	placeholder={component.placeholder}
																	format="n"
																	min={1}
																	max={7}
																	autoComplete="off"
																	value={days || 1}
																	valid={component.value < 15}
																	onChange={(value) => onChange(component.key, value)}
																/>
															)}
															{component.type === 'Switch' && (
																<span style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0px 5px 0px' }}>                                                                            
																	<Checkbox
																		style={{ outlined: 0 }}
																		// defaultChecked={component.value}
																		checked={component.value}
																		// onValueChange={(value) => onChange(component.key, value)}
																		onClick={(event) => onChange(component.key, event.target.checked)}
																		// onBlur={(value) => onDayChange(component,value,event)}
																	/>
																</span>
															)}
															{component.type === 'DropDownList' && (
																<span style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0px 5px 0px' }}>                                                                            
																	<DropDownList
																		style={{width: "120px"}}
																		data={categories}
																		defaultValue={viewType}
																		onChange={(event)=>onChange(component.key, event.value)}
																	/>
																</span>
															)}
															</Stack>
														</Box>
													)
												})}
											</Stack>
										</Box>
									</AccordionDetails>
								</Accordion>
							</div>
						</Box>
					</CardContent>
				</Grid>
			)}
			<Grid item={true} elevation={0} sx={{ flexGrow: 0, pl: '0', alignItems: 'center' }}>
				<Box className="arrow-btn" onClick={handleClick}>
					{isShow ? <ArrowBackIosRoundedIcon color='secondary.contrastText' /> : <ArrowForwardIosRoundedIcon color='secondary.contrastText' />}
				</Box>
			</Grid>
			<Grid item xs={12} ref={divRef} square component={Card} elevation={0} sx={{ p: 0, width: '100%', position: 'relative' }} className="filterbar-bg " onContextMenu={(e) => { e.preventDefault() }}>
				{props?.CustomButtons && <props.CustomButtons />}
				<Box sx={{ p: 0, display: 'flex', }} className='grid-movement topfix-ms bootom-slider-fix agenda-tileview'>
					<Eventcalendar
						// locale={()=>{localeEn.timeWheels='HH:mm'; return localeEn}}
						timeFormat='HH:mm'	
						// dataTimezone='local'
        				// displayTimezone='local'
						data={myEvents}
						view={props?.myView}
						refDate={props?.selectedDate}
						selectedDate={props?.selectedDate}
						colors={props?.myColors}
						dragToMove={true}
						dragToCreate={false}
						dragToResize={true}
						// eventOverlap={false}
						dragBetweenResources={viewType == Consts.Route?false:true}
						// clickToCreate="double"
						renderDay={props?.renderCustomDay}
						eventDelete={false}
						resources={myResources}
						renderResource={renderCustomResource}
						showEventTooltip={false}
						onEventHoverIn={onEventHoverIn}
						onEventHoverOut={props?.handleEventHoverOut}
                        renderScheduleEvent={(props) => <CustomScheduleEvent data={props} myEvents={eventData} onShowHideOverlappedEvents={onShowHideOverlappedEvents} onShowEventTooltip={onShowEventTooltip} iconActive={iconActive} dropOnScheduleEvent={dropOnScheduleEvent} visibleOverlappedEvents ={visibleOverlappedEvents} hiddenOverlappedEvents={hiddenOverlappedEvents.current}/> }
						// onResourceCollapse={(e) => console.log(e)}
						// onResourceExpand={(e) => console.log(e)}
						onCellRightClick={onCellRightClick}
						connections={myConnections}
						cssClass="md-timeline-height timeline-width"
						groupBy="date"
						showControls={true}	
						renderHeader={customHeader}					
						onSelectedDateChange={props.onSelectedDateChange}
						selectMultipleEvents={true}
						onSelectedEventsChange={handleSelectedEventsChange}
						onCellClick={handleCellClick}
						selectedEvents={selectedEvent}
						onEventRightClick={onEventRightClick}
						onEventDragStart={onEventDragStart}
						onEventDragEnd={onEventDragEnd}
						onEventUpdate={onEventUpdate}
						onEventDoubleClick={onEventDoubleClick}
						onEventUpdateFailed={onEventUpdateFailed}
						onEventUpdated={onEventUpdated}
						onEventClick={onEventClick}
					/>
					{showTimelineContextMenu && <ContextMenu flag="scheduler" Id={selectedEvent.length > 0 ? getSelectedValues() : null} routeId={getSelectedRoute()} routeIdAction={routeIdAction} removeAction={toggleconfigRemove.current} contextData={contextData} offset={offSet.current} card={toggleconfigCard} data={toggleconfigActions} sendToParent={onPlanButtons} />}
					{/* <TimeLineView/> */}
				</Box>
				<Box item={true} xs component={Card} elevation={0} pl={0} className='plan-action'>
					<Stack direction="row" className='disable-in-custom-view' spacing={1} zIndex={50} sx={{ borderRadius: 3, right: 2, top: { md: "0", lg: "0px", justifyContent: 'end', marginBottom: "0" } }}>
						{/* Plan Actions */}
						{planRelatedAction?.length > 0 && planRelatedAction.map((item,index) => {
							if(toggleconfigcheckboxesplan[item] && service.planActions.filter(e => e.key == item).length > 0) {
								const planActionBtn = service.planActions.filter(e => e.key == item)[0]
								return (
									<span key={index}>
										<Tooltip placement="bottom" title={planFunctionTooltip(planActionBtn?.key, planActionBtn?.title)}>
											<span>
											{
												planActionBtn?.btnType == "Button" && (
													<Button 
													variant={
														planActionBtn?.key === PlanFunctionsForFlag.ChangeSequence ? (
															changeSeqIcon ? "contained" : "outlined"
														) : planActionBtn?.key === Consts.ManualMode ? (
															manualModeIcon ? "contained" : "outlined"
														) : (
															'outlined'
														)
													}
													onClick={() => eval(planActionBtn?.onClick)}
													disabled={
														[PlanFunctionsForFlag.ChangeSequence,Consts.ManualMode].includes(planActionBtn?.key) ? (
															toggleIcon
														) : (
															eval(planActionBtn?.disabled)
														)
													}
													size="small" sx={{ px: .0, minWidth: '34px' }}>
														{planActionBtn?.key === Consts.ManualMode ? (
															manualModeIcon ? <ManualModeWhIcon /> : planActionBtn.icon
														) : planActionBtn?.key === PlanFunctionsForFlag.ChangeSequence ? (
															changeSeqIcon ? <ChangeCircleRoundedIcon /> : planActionBtn.icon
														) : (
															planActionBtn.icon
														)}
													</Button>
												)
											}
											{(planActionBtn.btnType == "IconButton" || planActionBtn.btnType =='ToggleButton') && (
												<IconButton size="large" 
												onClick={() => eval(planActionBtn?.onClick)}
												disabled={planActionBtn?.key === Consts.Calculate ? (manualModeIcon?true:eval(planActionBtn?.disabled)) : eval(planActionBtn?.disabled)}
												sx={{ m: 0, p: 0, marginTop: .5, }} color="primary">
												{planActionBtn.icon}
												</IconButton>
											)}
											</span>
										</Tooltip>
									</span>
								)
							}
						})}
						{/* Data Action */}
						{pataAction?.length > 0 && pataAction.map((item) => {
							if(toggleconfigcheckboxes && toggleconfigcheckboxes[item] && service?.dataActions?.filter(e => e.key == item)?.length > 0){
								const dataActionBtn = service.dataActions.filter(e => e.key == item)[0]
								if(eval(dataActionBtn?.isVisible))
								return (
									<>
										<span>
											<Tooltip placement="bottom" title={dataActionBtn?.title}>
												<span>
													{dataActionBtn.btnType == "IconButton" && (
													<IconButton size="large" sx={dataActionBtn?.sx} color="primary"
														id={dataActionBtn?.id}
														aria-haspopup={dataActionBtn?.ariaHaspopup}
														onClick={(e) => eval(dataActionBtn?.onClick)}>
														{dataActionBtn.icon}
													</IconButton>
													)}
												</span>
											</Tooltip>
										</span>
									</>
								)
								return null
							}
						})}
					</Stack>
				</Box>
			</Grid>
			<Box className='filterbar-bg disable-in-custom-view' sx={{ display: 'flex', }}>
				<Box className="arrow-btn" onClick={showToggleMenu}>
					{isShowToggleForConfig ? <ArrowForwardIosRoundedIcon color='secondary.contrastText' /> : <ArrowBackIosRoundedIcon color='secondary.contrastText' />}
				</Box>
				<Box className="overflow-datafix fix-heightMovement" sx={{ position: 'relative' }}>
					{isShowToggleForConfig &&
						<ToggleMenuForConfig gridFlagVal={entity} gridSelectedDataAction={[]} gridSelectedPlanAction={toggleconfigcheckboxesplan} gridSelectedActions={[]}  gridMenuItems={pataAction} griddefDataRelatedAction={[]}  toggleDraggedItem={toggleDraggedItem} gridPlanMenuItems={planRelatedAction} onDroppedItemsChange={droppedItemsChangeForRightClick} onCheckboxChange={toggleDataActionsRendering} onCheckboxChangePlan={toggleDataActionsRenderingPlan} />
					}
				</Box>
			</Box>
			{openConfirmationModal && <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />}
			<AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose} isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} isDisplayDrillDownButton={isDisplayDrillDownButton} drillDownButtonURL={drillDownButtonURL} />
			{openModalPopUp && <WindowComponent isPopup={true} title={commonPopupParameters?.title} visible={openModalPopUp} isWindowContent={true} initialWidth={1000} initialHeight={700} minWidth={300} minHeight={500} params={commonPopupParameters} sendDataToParent={handleChildState} closeConfirmationModal={closeConfirmationModal} onClose={() => setOpenModalPopUp(false)} />}
		</>
	)
}
